import { data } from "react-router-dom";
import "./App.css";

import React, { useState, createContext, useContext, useEffect, useMemo } from 'react';

import {
    Download, Loader2, Save, PlusCircle, Trash2,
    User, Briefcase, GraduationCap, Wrench, Info, LogIn, Sparkles, Menu
} from 'lucide-react';

import { ShieldCheck, Mail, Lock, ArrowRight } from 'lucide-react';

import {
    CheckCircle, Smartphone, Layout,
    Zap, Globe, Star
} from 'lucide-react';
import Guest from "./components/CVComponents/GuestForm";



// --- AUTHENTICATION CONTEXT ---
const AuthContext = React.createContext(null);
const useAuth = () => React.useContext(AuthContext); // Custom hook to use AuthContext // for accessing authentication state



// import LandingPage from "./components/LandingPage";

const BRAND_GREEN = '#198754';
const BRAND_RED = '#d14204ff';
const BRAND_DARK = '#157347';
const primaryColorCreate = 'bg-[#198754] hover:bg-green-700';
const primaryColorEdit = 'bg-orange-500 hover:bg-orange-600';

// let new_api_token = '';

const API_TOKEN_KEY = 'new_api_token';

// --- 1. CONTEXT SETUP ---
// Define initial data structure
const initialUserDetails = {
    // API Configuration
    apiToken: '',

    // CV Data Fields
    title: 'Senior Data Engineer CV',
    full_name: 'Jane Doe',
    email: 'jane.doe@example.com',
    phone: '+234 801 234 5678',
    country: 'Nigeria',
    city: 'Lagos',
    home_address: '123 Tech Drive',
    postal_code: '100001',
    linkedin_url: 'https://linkedin.com/in/janedoe',
    portfolio_url: 'https://github.com/janedoe',
    professional_summary: 'Highly experienced and results-driven Senior Data Engineer with 7+ years in building scalable data pipelines, optimizing ETL processes, and migrating complex on-premise systems to cloud platforms (AWS/GCP). Proven ability to drive data governance and implement robust data warehousing solutions.',
    skills: ['React, Node.js, Python, SQL, AWS, Docker'],
    work_experiences: [{ id: 1, job_title: 'Senior Data Engineer', company: 'TechCorp Solutions', location: 'Lagos, Nigeria', dates: '2021 - Present', responsibilities: '• Designed and implemented real-time data ingestion pipelines using Kafka and Flink.\n• Led migration of petabyte-scale data warehouse from on-premise to AWS Redshift, reducing query latency by 40%.\n• Mentored junior engineers on best practices for SQL optimization and Python development.' }],
    educations: [{ id: 1, degree: 'B.Sc Computer Science', institution: 'University of Lagos', location: 'Lagos, Nigeria', dates: '2015 - 2019', achievements: 'Graduated with First Class Honors' }],
    projects: [{ id: 1, name: 'Customer Churn Prediction Model', url: 'https://github.com/janedoe/churn', dates: '2023', summary: 'Developed a machine learning model using PySpark to predict customer churn with 92% accuracy, leading to targeted retention campaigns.' }],
    certifications: [{ id: 1, name: 'AWS Certified Solutions Architect', certificate_id: 'AWS-12345', url: 'https://aws.amazon.com/cert', dates: '2023/02/02', issuing_organization: 'Amazon Web Services', summary: '• Graduated among top 0.1%.\n• Learnt AWS at full-scale' }],

    // Template ID for the API call
    template_id: 3,

    // Placeholder for the CV ID returned by the API after creation
    createdCvId: null,
};

const initialUserDetails2 = {
    // API Configuration
    apiToken: '',

    // CV Data Fields
    title: 'Senior Data Engineer CV',
    full_name: 'John Daniel',
    email: 'john.daniel@example.com',
    phone: '+234 801 234 5678',
    country: 'Nigeria',
    city: 'Lagos',
    home_address: '123 Tech Drive',
    postal_code: '100001',
    linkedin_url: 'https://linkedin.com/in/johndaniel',
    portfolio_url: 'https://github.com/johndaniel',
    professional_summary: 'Highly experienced and results-driven Senior Data Engineer with 7+ years in building scalable data pipelines, optimizing ETL processes, and migrating complex on-premise systems to cloud platforms (AWS/GCP). Proven ability to drive data governance and implement robust data warehousing solutions.',
    skills: ['React, Node.js, Python, SQL, AWS, Docker'],
    work_experiences: [{ id: 1, job_title: 'Senior Data Engineer', company: 'TechCorp Solutions', location: 'Lagos, Nigeria', dates: '2021 - Present', responsibilities: '• Designed and implemented real-time data ingestion pipelines using Kafka and Flink.\n• Led migration of petabyte-scale data warehouse from on-premise to AWS Redshift, reducing query latency by 40%.\n• Mentored junior engineers on best practices for SQL optimization and Python development.' }],
    educations: [{ id: 1, degree: 'B.Sc Computer Science', institution: 'University of Lagos', location: 'Lagos, Nigeria', dates: '2015 - 2019', achievements: 'Graduated with First Class Honors' }],
    projects: [{ id: 1, name: 'Customer Churn Prediction Model', url: 'https://github.com/johndaniel/churn', dates: '2023', summary: 'Developed a machine learning model using PySpark to predict customer churn with 92% accuracy, leading to targeted retention campaigns.' }],
    certifications: [{ id: 1, name: 'AWS Certified Solutions Architect', certificate_id: 'AWS-12345', url: 'https://aws.amazon.com/cert', dates: '2023/02/02', issuing_organization: 'Amazon Web Services', summary: '• Graduated among top 0.1%.\n• Learnt AWS at full-scale' }],

    // Template ID for the API call
    template_id: 3,

    // Placeholder for the CV ID returned by the API after creation
    createdCvId: null,
};

// const templates = [
//     { id: 1, name: "Simple & Clean", type: "Simple", description: "Classic, single-column design. Minimalist and easy to read." },
//     { id: 2, name: "ATS Optimized", type: "ATS", description: "Structured, plain format for maximum Applicant Tracking System compatibility." },
//     { id: 3, name: "Modern & Bold", type: "Modern", description: "Visually distinct, two-column layout with a sidebar for contact details." },
//     { id: 4, name: "Creative & Colorful", type: "CreativeColorful", description: "A creative and colorful template with good looks and feel." },
//     { id: 5, name: "Minimalist & Sleek", type: "MinimalistSleek", description: "A clean, editorial-style layout with high-end typography and a structured grid for a professional look." },
//     { id: 6, name: "Classic & Timeless", type: "ClassicTimeless", description: "A traditional, centered layout that emphasizes professional reliability and clear hierarchy." },
//     { id: 7, name: "Bold & Dynamic", type: "BoldDynamic", description: "A high-impact template featuring dark headers and a strong modern structure." },
//     {
//         id: 8,
//         name: "Elegant & Refined",
//         type: "ElegantRefined",
//         description: "A sophisticated layout using ample white space, refined borders, and a balanced sidebar."
//     },
//     {
//         id: 9,
//         name: "Vibrant & Energetic",
//         type: "VibrantEnergetic",
//         description: "A high-energy, modern layout featuring bold typography and clear section breaks."
//     },
//     {
//         id: 10,
//         name: "Futuristic & Tech Savvy",
//         type: "FuturisticTechSavvy",
//         description: "A clean, high-contrast layout featuring centered headers and decorative skill indicators."
//     }

// ];

const CVContext = createContext();

const useCVContext = () => {
    return useContext(CVContext);
};

const CVProvider = ({ children }) => {

    const [templates, setTemplates] = useState([]);
    const [loadingTemplates, setLoadingTemplates] = useState(true);


    const [userDetails, setUserDetails] = useState(initialUserDetails);
    // console.log(userDetails); // To see if the Skills field even exists at all 

    // ✅ STEP 1: DEFINE the function
    const resetUserDetails = () => {
        // Retain the existing apiToken during a reset, 
        // especially if you are transitioning from one CV to a new one
        // and the user is authenticated (using the Auth Context token).
        const currentToken = userDetails.apiToken;

        // Reset to initial state, keeping the current token if needed
        setUserDetails(prev => ({
            ...initialUserDetails,
            apiToken: currentToken || initialUserDetails.apiToken // Retains token
        }));
    };


    // Effect to persist the apiToken to localStorage whenever it changes in the state
    useEffect(() => {
        if (userDetails.apiToken) {
            localStorage.setItem(API_TOKEN_KEY, userDetails.apiToken);
        } else {
            // Remove token from storage if user clears the input
            localStorage.removeItem(API_TOKEN_KEY);
        }
    }, [userDetails.apiToken]);

    return (
        // ✅ STEP 2: PROVIDE the function
        <CVContext.Provider value={{
            userDetails,
            setUserDetails,
            resetUserDetails, // <-- Add this
            templates // <-- Keep this if templates is defined
        }}>
            {children}
        </CVContext.Provider>
    );
};

// --- GLOBAL UTILITIES ---
const inputClasses = "w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#198754] transition placeholder-gray-500";
const sectionInputClasses = "p-2 border border-gray-300 rounded focus:ring-1 focus:ring-[#198754]/50";
const primaryColor = 'bg-[#198754] hover:bg-[#157347] hover:shadow-lg transition duration-200';
const dashedButton = 'w-full p-2 border border-dashed border-[#198754] text-[#198754] rounded-lg hover:bg-[#e6f2ed] transition duration-200';
const secondaryButton = 'px-6 py-2 rounded-full font-semibold text-[#198754] border border-[#198754] hover:bg-[#e6f2ed] transition duration-200';

// Helper function to render bulleted lists from newline-separated text
const ListRenderer = ({ text }) => {
    if (!text) return null;
    const items = text.split('\n').filter(line => line.trim() !== '');
    return (
        <ul className="list-disc ml-5 space-y-1">
            {items.map((item, index) => (
                <li key={index}>{item.replace(/^(\s*[\•\-\*]\s*)/, '')}</li>
            ))}
        </ul>
    );
};

const CV_PURCHASE_BASE_URL = 'https://cv.signup.com.ng/v1/api/cvs';

// const CV_PURCHASE_AMOUNT_URL = 'https://cv.signup.com.ng/v1/api/cvs/price';


// async function getCVPrice() {
//     const response = await fetch(`${CV_PURCHASE_BASE_URL}/price`);
//     const { price } = await response.json();
//     console.log(price);
//     return price;
// }


// console.log(CV_PURCHASE_AMOUNT_URL.price);

// const PURCHASE_AMOUNT = await getCVPrice(); // Naira

// Adding an authentication functionality right before users can start filling in their cv details.

const UserDashboardPage = ({ navigate }) => {
    const [currentBalance, setCurrentBalance] = useState(0);

    const { auth, logout } = useAuth();

    const user = auth?.user;

    console.log(auth)
    const isReferred = user?.is_referred ?? false;
    console.log("Line 225: Was User Referred? " + isReferred);
    console.log("User object:", user);
    console.log("Is Referred:", isReferred);

    // Assuming useCVContext provides a reset function
    const { userDetails, resetUserDetails, /*updateUserBalanceInContext*/ } = useCVContext();

    const [cvs, setCvs] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    // --- NEW STATE FOR FILTERING ---
    const [viewFilter, setViewFilter] = useState('all'); // 'all', 'paid', 'draft'
    // --- END NEW STATE FOR FILTERING ---

    // State for deletion confirmation
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [cvToDelete, setCvToDelete] = useState(null); // { id: number, title: string }
    const [isDeleting, setIsDeleting] = useState(false); // Loading state for deletion

    // --- NEW PURCHASE STATES ---
    const [showPurchaseConfirm, setShowPurchaseConfirm] = useState(false);
    const [cvToPurchase, setCvToPurchase] = useState(null); // { id: number, title: string }
    const [isPurchasing, setIsPurchasing] = useState(false); // Loading state for purchasing
    // --- END NEW PURCHASE STATES ---

    const [referralCode, setReferralCode] = useState('');

    const [purchaseAmount, setPurchaseAmount] = useState(0);


    const handleConfirmPurchase = (cvId, cvTitle) => {
        // Check if the user has enough balance before showing the modal
        if (currentBalance < purchaseAmount) {
            setError(`Error: Insufficient balance. You need ₦${purchaseAmount.toLocaleString()} in your wallet to purchase this CV, you can also do a bank transfer to pay.`);
            return;
        }
        setCvToPurchase({ id: cvId, title: cvTitle });
        setShowPurchaseConfirm(true);
    };

    async function getCVPrice(isReferred) {
        try {
            const response = await fetch(`${CV_PURCHASE_BASE_URL}/price`);
            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || "Failed to fetch CV price");
            }

            const price = isReferred
                ? data?.referral_price
                : data?.price;

            return Number(price ?? 0);

        } catch (error) {
            console.error("Error fetching CV price:", error);
            return 0;
        }
    }

    useEffect(() => {
        const fetchPrice = async () => {
            try {
                if (typeof isReferred !== 'boolean') return;

                const price = await getCVPrice(isReferred);

                setPurchaseAmount(price);

            } catch (err) {
                console.error("Failed to fetch CV price:", err);
                setPurchaseAmount(0);
            }
        };

        fetchPrice();
    }, [isReferred]); useEffect(() => {
        const fetchPrice = async () => {
            try {
                if (typeof isReferred !== 'boolean') return;

                const price = await getCVPrice(isReferred);

                setPurchaseAmount(price);

            } catch (err) {
                console.error("Failed to fetch CV price:", err);
                setPurchaseAmount(0);
            }
        };

        fetchPrice();
    }, [isReferred]);

    useEffect(() => {
        const storedCode = localStorage.getItem('referral_code');
        if (storedCode) {
            setReferralCode(storedCode);
        }
    }, []);



    // const API_URL = 'https://test.signup.com.ng/v1/api/cvs';
    const API_URL = 'https://cv.signup.com.ng/v1/api/cvs';
    const USER_DETAILS_API_URL = 'https://cv.signup.com.ng/v1/api/auth/me';

    const API_TOKEN = auth.token;

    // const referral_code = auth.user.referral_code;
    // console.log(referral_code);

    const [copied, setCopied] = useState(false);

    const handleCopyReferralCode = async () => {
        if (!referralCode) return;

        try {
            await navigator.clipboard.writeText(referralCode);
            setCopied(true);

            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error("Failed to copy:", err);
        }
    };


    // --- DEDICATED BALANCE FETCH FUNCTION ---
    const fetchUserBalance = async (token) => {
        if (!token) return;

        try {
            const response = await fetch(USER_DETAILS_API_URL, { // Assuming this endpoint provides user data including balance
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });

            if (!response.ok) {
                // If fetching user details fails, we might just use the default 0 or context value
                console.error("Failed to fetch user details for balance update.");
                return;
            }

            const data = await response.json();
            // console.log(data.balance)
            // Assuming the balance is at data.user.balance or data.balance
            // Based on common patterns, I'll check both.
            const fetchedBalance = Number(data.balance || data.user?.balance);

            if (!isNaN(fetchedBalance)) {
                setCurrentBalance(fetchedBalance);
            }
        } catch (err) {
            console.error("Error fetching user balance:", err);
            // Optionally set an error visible to the user
        }
    };
    // --- END DEDICATED BALANCE FETCH FUNCTION ---


    // FIX: Define handleEdit outside of useEffect so it's globally accessible in the component
    const handleEdit = (cvId) => {
        // 1. Reset the form context to clear any previous CV data (optional but safer)
        if (resetUserDetails) {
            resetUserDetails();
        }

        // 2. Navigate to the form page (step 1) and pass the cvId
        navigate(1, cvId);
    };

    // --- DELETE FUNCTIONALITY ---

    // 1. Opens the confirmation modal
    const handleConfirmDelete = (cvId, cvTitle) => {
        setCvToDelete({ id: cvId, title: cvTitle });
        setShowDeleteConfirm(true);
    };

    const handleDeleteCV = async () => {
        // Validation: must have a CV selected and not already processing
        if (!cvToDelete || !cvToDelete.id || isDeleting) return;

        setError(null);
        setIsDeleting(true);
        setShowDeleteConfirm(false);

        try {
            const response = await fetch(`${API_URL}/${cvToDelete.id}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${API_TOKEN}`,
                    'Content-Type': 'application/json',
                }
            });

            if (!response.ok) {
                const errorBody = await response.json().catch(() => ({ message: 'Could not delete CV.' }));
                throw new Error(errorBody.message || `HTTP error! Status: ${response.status}`);
            }

            // SUCCESS LOGIC:
            // 1. Remove the item from the local state list instantly
            setCvs(prevCvs => prevCvs.filter(cv => cv.id !== cvToDelete.id));

            // 2. Provide user feedback
            setError(`Success! CV "${cvToDelete.title}" was deleted.`);

        } catch (err) {
            console.error("Failed to delete CV:", err);
            setError(`Error deleting CV: ${err.message}`);
        } finally {
            setIsDeleting(false);
            setCvToDelete(null);
        }
    };

    // 3. Closes the confirmation modal without deleting
    const handleCancelDelete = () => {
        setShowDeleteConfirm(false);
        setCvToDelete(null);
    };

    // --- NEW PURCHASE FUNCTIONALITY ---

    // 1. Opens the purchase confirmation modal
    // const handleConfirmPurchase = (cvId, cvTitle) => {
    //     // Check if the user has enough balance before showing the modal
    //     if (currentBalance < purchaseAmount) {
    //         setError(`Error: Insufficient balance. You need ₦${purchaseAmount.toLocaleString()} to purchase this CV.`);
    //         return;
    //     }
    //     setCvToPurchase({ id: cvId, title: cvTitle });
    //     setShowPurchaseConfirm(true);
    // };

    const handlePurchaseCV = async () => {
        if (!cvToPurchase || !cvToPurchase.id || isPurchasing) return;

        setError(null);
        setIsPurchasing(true);
        setShowPurchaseConfirm(false); // Close the modal immediately

        try {
            const response = await fetch(`${CV_PURCHASE_BASE_URL}/${cvToPurchase.id}/purchase`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${API_TOKEN}`,
                    'Content-Type': 'application/json',
                }
            });
            console.log(`${CV_PURCHASE_BASE_URL}/${cvToPurchase.id}/purchase`);

            console.log(response);
            const responseData = await response.json();
            console.log(responseData);

            if (!response.ok) {
                // Handle non-2xx status codes (e.g., balance too low, already paid)
                const errorDetail = responseData.error || responseData.message || `HTTP error! Status: ${response.status}`;
                throw new Error(errorDetail);
            }

            // Success: CV purchased

            // 1. Update the local state to reflect paid status
            setCvs(prevCvs => prevCvs.map(cv =>
                cv.id === cvToPurchase.id ? { ...cv, paid: true } : cv
            ));

            // 2. Update the balance state immediately from the response
            const newBalance = Number(responseData.balance);
            console.log(responseData);

            console.log(newBalance);
            setError(`Success! CV "${cvToPurchase.title}" purchased. Kindly refresh to see your new balance}.`); // for now, I can't really tell which field has the actual balance.
            // setError(`Success! CV "${cvToPurchase.title}" purchased. Your new balance is: ₦${newBalance.toLocaleString()}.`);

        } catch (err) {
            // console.error("Failed to purchase CV:", err);
            // setError(`Error purchasing CV: ${err.message}.`);

            const isInsufficient = err.message.includes('Insufficient balance');
            const userError = isInsufficient
                ? `${err.message}. The required purchase amount is ₦${purchaseAmount.toLocaleString()}. Please check your current balance displayed above.`
                : err.message;

            // Show the user the specific error message (e.g., "Insufficient balance")
            setError(`Error purchasing CV: ${userError}`);
        } finally {
            setIsPurchasing(false);
            setCvToPurchase(null); // Clear the CV to purchase after operation
        }
    };

    // 3. Closes the purchase confirmation modal without purchasing
    const handleCancelPurchase = () => {
        setShowPurchaseConfirm(false);
        setCvToPurchase(null);
    };

    const filteredCvs = useMemo(() => {
        if (!cvs || !Array.isArray(cvs)) return [];

        if (viewFilter === 'paid') {
            return cvs.filter(cv => cv.paid);
        }
        if (viewFilter === 'draft') {
            // Assuming !cv.paid means it's a draft/unpaid
            return cvs.filter(cv => !cv.paid);
        }
        return cvs; // 'all'
    }, [cvs, viewFilter]);

    // --- FETCH EFFECT ---
    useEffect(() => {
        // Only fetch if a token is available
        if (!API_TOKEN) {
            setIsLoading(false);
            setError("Authentication token missing. Please ensure you are properly signed in.");
            return;
        }

        const fetchCvs = async () => {
            setIsLoading(true);
            setError(null); // Clear previous errors

            // 1. Check context for initial balance (if reliable)
            if (userDetails?.balance !== undefined && !isNaN(Number(userDetails.balance))) {
                setCurrentBalance(Number(userDetails.balance));
            } else {
                // 2. Fetch the current balance if not in context or unreliable
                await fetchUserBalance(API_TOKEN);
            }

            // 3. Fetch the list of CVs
            try {
                // Simulate network delay
                await new Promise(resolve => setTimeout(resolve, 1000));

                const response = await fetch(API_URL, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${API_TOKEN}`,
                        'Content-Type': 'application/json',
                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const data = await response.json();
                const fetchedCvs = data.data || data;

                if (Array.isArray(fetchedCvs)) {
                    setCvs(fetchedCvs);
                    setError(null);
                } else {
                    throw new Error("API response was not a list of CVs.");
                }

            } catch (err) {
                console.error("Failed to fetch CVs:", err);
                navigate(5)
                // setError(`(Simulated Error: Failed to fetch real data using API. Displaying mock data for structure check.)`);
                // setCvs([
                //     { id: 1, title: "Mock CV - Senior Software Developer", created_at: "2024-10-15", full_name: "Mock User 1" },
                //     { id: 2, title: "Mock CV - Marketing Coordinator", created_at: "2024-09-28", full_name: "Mock User 2" }
                // ]);
                // setTimeout(() => {
                //     navigate(5);
                // }, 1500);

            } finally {
                setIsLoading(false);
            }
        };

        fetchCvs();
    }, [API_TOKEN]);

    return (
        <div className="min-h-screen bg-gray-50 p-4 sm:p-8">
            <div className="max-w-4xl mx-auto bg-white p-6 sm:p-10 rounded-2xl shadow-2xl">
                <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-6 mb-8 border-b pb-6">

                    <h2
                        className="text-3xl md:text-4xl font-extrabold text-gray-900 tracking-tight"
                        style={{ borderColor: BRAND_GREEN }}
                    >
                        User Dashboard
                    </h2>

                    <div className="w-full md:w-auto bg-white rounded-2xl shadow-md border border-gray-200 p-5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">

                        <div>
                            <p className="text-xs uppercase tracking-wide text-gray-500 font-semibold">
                                Current Balance
                            </p>
                            <p className="text-2xl md:text-3xl font-bold text-teal-600 mt-1">
                                ₦{Number(currentBalance).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                            </p>
                        </div>

                        <a
                            href="https://signup.com.ng/hub"
                            className="inline-flex items-center justify-center px-4 py-2 rounded-xl bg-teal-600 text-white text-sm font-semibold shadow-sm hover:bg-teal-700 transition-all duration-200 hover:shadow-md active:scale-95"
                        >
                            View Balance
                        </a>

                    </div>
                </div>

                {/* --- REFERRAL CODE SECTION --- */}
                <div className="mb-6 p-4 bg-gradient-to-r from-teal-50 to-green-50 border border-teal-200 rounded-xl shadow-sm">
                    <p className="text-sm font-semibold text-gray-600 mb-2">
                        Your Referral Code
                    </p>

                    <div className="flex items-center justify-between gap-3 flex-wrap">
                        <div className="flex-1 min-w-[200px] bg-white border border-gray-200 rounded-lg px-4 py-2 font-mono text-lg text-gray-800 shadow-inner">
                            {referralCode || 'No referral code available'}
                        </div>

                        <button
                            onClick={handleCopyReferralCode}
                            disabled={!referralCode}
                            className={`px-4 py-2 rounded-lg text-sm font-semibold transition shadow-md 
                ${referralCode
                                    ? 'bg-teal-600 text-white hover:bg-teal-700'
                                    : 'bg-gray-200 text-gray-400 cursor-not-allowed'
                                }`}
                        >
                            {copied ? 'Copied!' : 'Copy'}
                        </button>
                    </div>

                    <p className="text-xs text-gray-500 mt-2">
                        Share this code with friends and earn rewards when they sign up.
                    </p>
                </div>

                <p className="text-sm text-gray-500 mb-6 italic">
                    {/* Showing a List of CVs this particular user with the signed in email has created. */}
                    Manage your created CVs and review your paid copies below.
                </p>

                {/* --- FILTER & ACTION CONTROLS --- */}
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 space-y-4 sm:space-y-0">
                    {/* Filter Segmented Control */}
                    <div className="flex bg-gray-200 rounded-xl p-1 shadow-inner">
                        <button
                            onClick={() => setViewFilter('all')}
                            className={`px-4 py-2 text-sm font-medium rounded-lg transition-all ${viewFilter === 'all' ? 'bg-white text-gray-900 shadow' : 'text-gray-600 hover:text-gray-900'}`}
                        >
                            All CVs ({cvs.length})
                        </button>
                        <button
                            onClick={() => setViewFilter('paid')}
                            className={`px-4 py-2 text-sm font-medium rounded-lg transition-all ${viewFilter === 'paid' ? 'bg-white text-gray-900 shadow' : 'text-gray-600 hover:text-gray-900'}`}
                        >
                            Paid CVs ({cvs.filter(cv => cv.paid).length})
                        </button>
                        <button
                            onClick={() => setViewFilter('draft')}
                            className={`px-4 py-2 text-sm font-medium rounded-lg transition-all ${viewFilter === 'draft' ? 'bg-white text-gray-900 shadow' : 'text-gray-600 hover:text-gray-900'}`}
                        >
                            Drafts / Unpaid ({cvs.filter(cv => !cv.paid).length})
                        </button>
                    </div>

                    {/* Create New CV Button */}
                    <button
                        onClick={() => navigate(1)}
                        className="text-sm font-semibold text-white px-5 py-2 rounded-lg transition duration-200 shadow-md hover:opacity-90 flex items-center"
                        style={{ backgroundColor: BRAND_GREEN }}
                    >
                        + Create New CV
                    </button>
                </div>

                {/* Info alert to guide the user since polling is off */}
                {cvs.some(cv => cv.paid && cv.generate_status !== 'completed') && (
                    <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-lg text-blue-700 text-xs flex items-center gap-2">
                        <info className="w-4 h-4" />
                        <span>Some CVs are currently in the generation queue. Please <strong>refresh the page</strong> in a few minutes to see your download links.</span>
                    </div>
                )}

                <br />
                {(isLoading || isDeleting || isPurchasing) && (
                    <div className="flex items-center justify-center p-12 text-gray-600">
                        <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        {isDeleting ? 'Processing deletion...' : isPurchasing ? 'Processing purchase...' : 'Loading your past CVs...'}
                    </div>
                )}

                {error && (
                    <div className={`border px-4 py-3 rounded-lg relative mb-4 ${error.includes('Error') ? 'bg-red-100 border-red-400 text-red-700' : 'bg-green-100 border-green-400 text-green-700'}`} role="alert">
                        <strong className="font-bold">{error.includes('Success') ? 'Notification:' : 'Fetch/Action Warning:'}</strong>
                        <span className="block sm:inline ml-2">{error}</span>
                    </div>
                )}


                {!isLoading && filteredCvs.length === 0 && !error && (
                    <p className="text-xl text-gray-500 p-12 text-center border-dashed border-2 rounded-xl">
                        {viewFilter === 'paid' && 'You have no purchased CVs yet.'}
                        {viewFilter === 'draft' && 'You have no drafts or unpaid CVs.'}
                        {viewFilter === 'all' && 'You haven\'t created any CVs yet. Start building one now!'}
                    </p>
                )}

                {!isLoading && filteredCvs.length > 0 && (
                    <ul className={`space-y-4 ${(isDeleting || isPurchasing) ? 'opacity-50 pointer-events-none' : ''}`}>
                        {filteredCvs.map((cv) => {
                            // Validation Logic
                            const isPaid = cv.paid === true;
                            const isCompleted = cv.generate_status === 'completed';
                            const hasUrl = cv.cv_url !== null;
                            const canDownload = isCompleted && hasUrl;

                            return (
                                <li key={cv.id} className="p-4 border border-gray-200 bg-white rounded-xl hover:shadow-lg transition duration-200 flex flex-col sm:flex-row justify-between items-start sm:items-center">
                                    <div className="mb-4 sm:mb-0">
                                        <p className="font-semibold text-lg text-gray-800">
                                            {cv.title || `CV ID: ${cv.id}`}
                                            {isPaid ? (
                                                <span className="ml-3 inline-flex items-center px-3 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">Paid</span>
                                            ) : (
                                                <span className="ml-3 inline-flex items-center px-3 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">Unpaid / Draft</span>
                                            )}
                                        </p>
                                        <p className="text-sm text-teal-600">Full Name on CV: {cv.full_name || 'N/A'}</p>
                                        <div className="flex flex-wrap gap-x-4">
                                            <p className="text-sm text-gray-500">Created: {new Date(cv.created_at).toLocaleDateString()}</p>
                                            {isPaid && (
                                                <p className={`text-sm font-medium ${isCompleted ? 'text-green-600' : 'text-amber-500 italic'}`}>
                                                    Status: {cv.generate_status.charAt(0).toUpperCase() + cv.generate_status.slice(1)}
                                                    {!isCompleted && " (Refresh page to update)"}
                                                </p>
                                            )}
                                        </div>
                                    </div>

                                    <div className="flex space-x-3 flex-shrink-0 w-full sm:w-auto mt-3 sm:mt-0">
                                        {/* Download Button - Rule 1: Show only when paid */}
                                        {isPaid && (
                                            <button
                                                disabled={!canDownload}
                                                onClick={() => window.open(cv.cv_url, '_blank')}
                                                className={`text-sm font-bold px-4 py-2 rounded-lg flex items-center gap-2 transition-all shadow-md
                                                    ${canDownload
                                                        ? 'bg-indigo-600 text-white hover:bg-indigo-700'
                                                        : 'bg-gray-100 text-gray-400 cursor-not-allowed border border-gray-200'
                                                    }`}
                                            >
                                                {!isCompleted ? (
                                                    <span className="animate-pulse flex items-center gap-1">
                                                        <div className="w-2 h-2 bg-amber-400 rounded-full"></div>
                                                        In Queue...
                                                    </span>
                                                ) : (
                                                    <>
                                                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" /></svg>
                                                        Download CV
                                                    </>
                                                )}
                                            </button>
                                        )}

                                        <button
                                            onClick={() => handleEdit(cv.id)}
                                            className="text-sm font-medium px-4 py-2 rounded-lg text-white transition duration-200 shadow-md hover:opacity-90"
                                            style={{ backgroundColor: BRAND_GREEN }}
                                            disabled={isDeleting || isPurchasing}
                                        >
                                            Edit
                                        </button>

                                        {!isPaid && (
                                            <button
                                                onClick={() => handleConfirmPurchase(cv.id, cv.title || `CV ID: ${cv.id}`)}
                                                className="text-sm font-medium px-4 py-2 rounded-lg text-white transition duration-200 shadow-md hover:opacity-90 bg-blue-600 hover:bg-blue-700"
                                                disabled={isDeleting || isPurchasing}
                                            >
                                                Purchase
                                            </button>
                                        )}

                                        <button
                                            onClick={() => handleConfirmDelete(cv.id, cv.title || `CV ID: ${cv.id}`)}
                                            className="text-sm font-medium px-4 py-2 rounded-lg text-white transition duration-200 shadow-md hover:opacity-90 bg-red-600 hover:bg-red-700"
                                            disabled={isDeleting || isPurchasing}
                                        >
                                            Delete
                                        </button>
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                )}



                <div className="mt-8 pt-6 border-t flex justify-end">
                    <button
                        onClick={() => navigate(1)}
                        className="text-white font-semibold px-6 py-3 rounded-lg shadow-xl transition duration-300 transform hover:scale-[1.02]"
                        style={{ backgroundColor: BRAND_GREEN }}
                        disabled={isDeleting}
                    >
                        Create New CV &rarr;
                    </button>
                </div>
            </div>

            {/* --- CONFIRMATION MODAL UI --- */}
            {showDeleteConfirm && cvToDelete && (
                <div className="fixed inset-0 bg-gray-600 bg-opacity-75 flex items-center justify-center p-4 z-50 transition-opacity">
                    <div className="bg-white rounded-xl shadow-2xl p-6 w-full max-w-md transform transition-all scale-100">
                        <h3 className="text-2xl font-bold text-gray-900 mb-4">Confirm Deletion</h3>
                        <p className="text-gray-700 mb-6">
                            Are you sure you want to permanently delete the CV titled:
                            <span className="font-semibold text-red-600 block mt-2 p-2 bg-red-50 rounded-lg">
                                "{cvToDelete.title}" (ID: {cvToDelete.id})
                            </span>
                        </p>
                        <p className="text-sm text-gray-500 mb-8">
                            This action cannot be undone.
                        </p>
                        <div className="flex justify-end space-x-4">
                            <button
                                onClick={handleCancelDelete}
                                className="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-100 transition"
                                disabled={isDeleting}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleDeleteCV}
                                className="px-6 py-2 rounded-lg text-white bg-red-600 hover:bg-red-700 transition font-semibold"
                                disabled={isDeleting}
                            >
                                {isDeleting ? 'Deleting...' : 'Yes, Delete It'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* --- CONFIRMATION MODAL UI (PURCHASE) --- */}
            {showPurchaseConfirm && cvToPurchase && (
                <div className="fixed inset-0 bg-gray-600 bg-opacity-75 flex items-center justify-center p-4 z-50 transition-opacity">
                    <div className="bg-white rounded-xl shadow-2xl p-6 w-full max-w-md transform transition-all scale-100">
                        <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                            Confirm CV Purchase
                            <span className="ml-3 text-base font-semibold text-blue-600 bg-blue-100 px-3 py-1 rounded-full">
                                {/* ₦{PURCHASE_AMOUNT.toLocaleString()} */}
                                ₦{Number(purchaseAmount ?? 0).toLocaleString()}
                            </span>
                        </h3>
                        <p className="text-gray-700 mb-4">
                            You are about to purchase the CV titled:
                            <span className="font-semibold text-gray-800 block mt-2 p-2 bg-gray-50 rounded-lg">
                                "{cvToPurchase.title}"
                            </span>
                        </p>
                        <p className="text-sm text-red-500 font-medium mb-6">
                            ⚠️ Please ensure you have completed all editing before purchasing. The transaction will proceed immediately.
                        </p>
                        <div className="flex justify-end space-x-4">
                            <button
                                onClick={handleCancelPurchase}
                                className="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-100 transition"
                                disabled={isPurchasing}
                            >
                                Cancel / Go Back to Edit
                            </button>
                            <button
                                onClick={handlePurchaseCV}
                                className="px-6 py-2 rounded-lg text-white bg-blue-600 hover:bg-blue-700 transition font-semibold"
                                disabled={isPurchasing}
                            >
                                {isPurchasing ? 'Processing...' : 'Confirm & Pay'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {/* --- END CONFIRMATION MODAL UI (PURCHASE) --- */}


            {/* --- END CONFIRMATION MODAL UI --- */}
        </div>
    );
};


const CVFormPage = ({ navigate, cvIdToEdit }) => {

    // *** NEW: Get token and isAuthenticated from Auth Context ***
    const { auth, logout } = useAuth();
    // Use the context token


    // Assuming useCVContext provides userDetails, setUserDetails, and resetUserDetails
    const { userDetails, setUserDetails, resetUserDetails } = useCVContext();
    const [formStatus, setFormStatus] = useState(null);
    const [isFetchingData, setIsFetchingData] = useState(false); // New state for loading indicator
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Logic to prepare data for backend
    const handleNextStep = async () => {
        setIsSubmitting(true);

        // 1. Process skills into an array
        // We trim whitespace and filter out any empty strings resulting from trailing commas
        const skillsArray = (userDetails.skills || '')
            .split(',')
            .map(skill => skill.trim())
            .filter(skill => skill !== '');

        // 2. Construct payload
        const payload = {
            ...userDetails,
            skills: skillsArray // Sending as array instead of string
        };

        console.log("Payload being sent to server:", payload);

        // Simulate API call
        setTimeout(() => {
            setIsSubmitting(false);
            navigate('/cvTemplates');
        }, 1000);
    };

    // Determine the mode
    const isEditMode = !!cvIdToEdit;

    // const API_URL = 'https://test.signup.com.ng/v1/api/cvs';
    const API_URL = 'https://cv.signup.com.ng/v1/api/cvs';
    const API_TOKEN = auth.token;

    // const API_TOKEN = userDetails.apiToken; // Token from the form input

    // 1. useEffect for fetching CV data if in Edit Mode (GET /cvs/:id)
    useEffect(() => {
        // Clear status when component mounts or mode changes
        setFormStatus(null);

        if (isEditMode && API_TOKEN) {
            const fetchCvDetails = async () => {
                setIsFetchingData(true);
                try {
                    const response = await fetch(`${API_URL}/${cvIdToEdit}`, {
                        method: 'GET',
                        headers: {
                            'Authorization': `Bearer ${API_TOKEN}`,
                            'Content-Type': 'application/json',
                        }
                    });

                    // if (!response.ok) {
                    //     throw new Error(`Failed to fetch CV details. Status: ${response.status}`);
                    // }

                    if (!response.ok) {
                        // if token is invalid, log user out and move them to login page
                        if (response.status === 401) {
                            logout();
                            navigate('login'); // Redirect to login
                        }
                        throw new Error(`Failed to fetch CV details. Status: ${response.status}`);
                    }

                    const data = await response.json();

                    // The API response structure might wrap the CV data
                    const cvData = data.data || data;

                    // Add the apiToken back to the fetched data before setting
                    const dataToSet = {
                        ...cvData,
                        // Ensure the token from the context is retained, as it's not returned by the GET
                        // apiToken: API_TOKEN
                    };

                    setUserDetails(dataToSet);
                    setFormStatus('success_fetch');

                } catch (err) {
                    console.error("Error fetching CV for edit:", err);
                    setFormStatus('error_fetch');
                } finally {
                    setIsFetchingData(false);
                }
            };
            fetchCvDetails();
        } else if (!isEditMode && resetUserDetails) {
            // If in create mode, ensure the form is cleared (assuming resetUserDetails exists)
            // It's crucial not to call resetUserDetails if in edit mode, as it would clear the token before the fetch.
            resetUserDetails();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cvIdToEdit, API_TOKEN]); // Rerun if token changes

    // Handles changes for simple fields (including the apiToken)
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setUserDetails(prev => ({ ...prev, [name]: value }));
    }

    // Handles changes for array items
    const handleSectionChange = (section, id, field, value) => {
        setUserDetails(prev => ({
            ...prev,
            [section]: (prev[section] || []).map(item =>
                item.id === id ? { ...item, [field]: value } : item
            )
        }));
    };

    // Adds a new entry to any array section
    const handleAddEntry = (section) => {
        const newId = Date.now();
        let newEntry = { id: newId };

        switch (section) {
            case 'work_experiences':
                newEntry = { id: newId, job_title: '', company: '', location: '', dates: '', responsibilities: '' };
                break;
            // When the skills attribute is added
            case 'skills':
                newEntry = { id: newId, skills: '' };
            case 'educations':
                newEntry = { id: newId, degree: '', institution: '', location: '', dates: '', achievements: '' };
                break;
            case 'projects':
                newEntry = { id: newId, name: '', url: '', dates: '', summary: '' };
                break;
            case 'certifications':
                newEntry = { id: newId, name: '', certificate_id: '', url: '', dates: '', summary: '', issuing_organization: '' };
                break;
            default:
                return;
        }

        setUserDetails(prev => ({
            ...prev,
            [section]: [...(prev[section] || []), newEntry]
        }));
    };

    // Removes an entry from any array section
    const handleRemoveEntry = (section, id) => {
        setUserDetails(prev => ({
            ...prev,
            [section]: (prev[section] || []).filter(item => item.id !== id)
        }));
    };

    // Updated handleFormSubmit for both POST (Create) and PUT (Edit)
    const handleFormSubmit = async (e) => {
        e.preventDefault();

        // --- Validation Check ---
        if (!userDetails.full_name || !userDetails.email || !userDetails.title || !userDetails.professional_summary) {
            setFormStatus('error_validation');
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return;
        }

        // --- Edit Mode (PUT) ---
        if (isEditMode) {
            setFormStatus('loading_edit');

            // Prepare the payload (remove temporary client-side keys like 'id' from nested arrays)
            const preparePayload = (data) => {
                const payload = { ...data };
                // delete payload.apiToken; // Don't send token in body

                // Recursively remove the client-side 'id' from arrays
                if (payload.work_experiences) payload.work_experiences = payload.work_experiences.map(({ id, ...rest }) => rest);
                if (payload.educations) payload.educations = payload.educations.map(({ id, ...rest }) => rest);
                if (payload.projects) payload.projects = payload.projects.map(({ id, ...rest }) => rest);
                if (payload.certifications) payload.certifications = payload.certifications.map(({ id, ...rest }) => rest);

                return payload;
            };

            const payload = preparePayload(userDetails);

            try {
                const response = await fetch(`${API_URL}/${cvIdToEdit}`, {
                    method: 'PUT',
                    headers: {
                        'Authorization': `Bearer ${API_TOKEN}`,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(payload)
                });

                if (!response.ok) {
                    const errorBody = await response.json().catch(() => ({ message: 'Unknown error occurred.' }));
                    throw new Error(errorBody.message || `HTTP error! Status: ${response.status}`);
                }

                // Success: Redirect back to the dashboard (step 4)
                setFormStatus('success_edit');
                setTimeout(() => {
                    navigate(4);
                }, 1500);

            } catch (err) {
                console.error("Error updating CV:", err);
                setFormStatus('error_edit');
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }

        } else {
            // --- Create Mode (POST), proceeds to Step 2 ---
            setFormStatus(null);
            // Save the token to local storage so the dashboard can access it later
            localStorage.setItem('new_api_token', userDetails.apiToken);
            navigate(2);
        }
    };

    // Dynamic rendering variables
    const primaryColor = isEditMode ? primaryColorEdit : primaryColorCreate;
    const headingText = isEditMode ? `Step 1: Edit CV (ID: ${cvIdToEdit})` : 'Step 1: Enter Details';
    const buttonText = isEditMode ? 'Save Changes & Review' : 'Review Data & Select Template (Step 2)';


    if (isFetchingData) {
        return (
            <div className="flex justify-center items-center h-screen bg-gray-50">
                <p className="text-xl font-semibold text-gray-600">Loading CV details for editing...</p>
            </div>
        );
    }

    return (
        <div className="bg-gray-50 min-h-screen flex flex-col items-center p-4 sm:p-8">

            <div className="w-full max-w-3xl">
                <div className="flex justify-between items-center mb-6">
                    <h1 className="text-3xl font-extrabold text-gray-900">{headingText}</h1>
                    <span className="text-sm font-semibold text-white bg-[#198754] px-4 py-1 rounded-full shadow-md">
                        {isEditMode ? 'Edit Mode' : '1/3'}
                    </span>
                </div>
                <p className="text-md text-gray-600 mb-8 text-center">
                    {isEditMode
                        ? 'Modify the details below and save your changes. The API Token is required to authenticate the update.'
                        : 'Fill in every section below.'}
                </p>
            </div>

            <button onClick={() => navigate(4)} className="text-sm text-[#198754] hover:underline flex items-center mt-2">
                See a list of CVs you have created in the past instead.
            </button>
            <br />

            <form onSubmit={handleFormSubmit} className="bg-white p-6 sm:p-10 rounded-xl shadow-2xl w-full max-w-3xl">
                {/* 1. PERSONAL DETAILS SECTION */}
                <h2 className="text-2xl font-bold mt-10 mb-4 text-gray-800 border-b pb-2">1. Personal Details & Summary</h2>
                <div className="space-y-4">
                    <input type="text" name="title" value={userDetails.title} onChange={handleInputChange} placeholder="CV Title (e.g., Senior Staff Data Engineer CV)" className={inputClasses} required />
                    <input type="text" name="full_name" value={userDetails.full_name} onChange={handleInputChange} placeholder="Full Name" className={inputClasses} required disabled={isEditMode} />
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <input type="email" name="email" value={userDetails.email} onChange={handleInputChange} placeholder="Email" className={inputClasses} required disabled={isEditMode} />
                        <input type="text" name="phone" value={userDetails.phone} onChange={handleInputChange} placeholder="Phone Number" className={inputClasses} disabled={isEditMode} />
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <input type="text" name="country" value={userDetails.country} onChange={handleInputChange} placeholder="Country" className={inputClasses} />
                        <input type="text" name="city" value={userDetails.city} onChange={handleInputChange} placeholder="City" className={inputClasses} />
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <input type="text" name="home_address" value={userDetails.home_address} onChange={handleInputChange} placeholder="Home Address" className={inputClasses} />
                        <input type="text" name="postal_code" value={userDetails.postal_code} onChange={handleInputChange} placeholder="Postal Code" className={inputClasses} />
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <input type="url" name="linkedin_url" value={userDetails.linkedin_url} onChange={handleInputChange} placeholder="LinkedIn URL" className={inputClasses} />
                        <input type="url" name="portfolio_url" value={userDetails.portfolio_url} onChange={handleInputChange} placeholder="Portfolio URL" className={inputClasses} />
                    </div>
                    <textarea
                        name="professional_summary" value={userDetails.professional_summary} onChange={handleInputChange}
                        placeholder="Professional Summary (Required)"
                        rows="5" className={`${inputClasses} resize-y`} required
                    />
                </div>

                {/* 2. WORK EXPERIENCE SECTION */}
                <h2 className="text-2xl font-bold mt-10 mb-4 text-gray-800 border-b pb-2">2. Work Experience</h2>
                <div className="space-y-6">
                    {(userDetails.work_experiences || []).map((job) => (
                        <div key={job.id} className="p-5 border border-gray-200 rounded-xl bg-gray-50 relative shadow-sm">
                            <button type="button" onClick={() => handleRemoveEntry('work_experiences', job.id)} className="absolute top-3 right-3 text-gray-400 hover:text-red-500 transition duration-150 p-1 rounded-full bg-white" title="Remove Experience Entry">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm6 0a1 1 0 10-2 0v6a1 1 0 102 0V8z" clipRule="evenodd" /></svg>
                            </button>
                            <h3 className="text-lg font-semibold mb-3 text-gray-700">Role: {job.job_title || 'New Role'}</h3>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                                <input type="text" value={job.job_title} onChange={(e) => handleSectionChange('work_experiences', job.id, 'job_title', e.target.value)} placeholder="Job Title" className={sectionInputClasses} required />
                                <input type="text" value={job.company} onChange={(e) => handleSectionChange('work_experiences', job.id, 'company', e.target.value)} placeholder="Company" className={sectionInputClasses} required />
                                <input type="text" value={job.location} onChange={(e) => handleSectionChange('work_experiences', job.id, 'location', e.target.value)} placeholder="Location" className={sectionInputClasses} required />
                                <input type="text" value={job.dates} onChange={(e) => handleSectionChange('work_experiences', job.id, 'dates', e.target.value)} placeholder="Dates (e.g., 2020 - 2024)" className={sectionInputClasses} required />
                            </div>
                            <textarea
                                value={job.responsibilities}
                                onChange={(e) => handleSectionChange('work_experiences', job.id, 'responsibilities', e.target.value)}
                                placeholder="Key responsibilities. Enter each point on a new line (will be converted to an array)."
                                rows="4" className={`${sectionInputClasses} w-full resize-y`} required
                            />
                        </div>
                    ))}
                    <button type="button" onClick={() => handleAddEntry('work_experiences')} className={dashedButton}>
                        + Add Work Experience Entry
                    </button>
                </div>

                {/* SKILLS SECTION */}
                <h2 className="text-2xl font-bold mt-10 mb-4 text-gray-800 border-b pb-2">3. Skills</h2> <Sparkles className="text-[#198754]" size={20} />
                {/* <textarea
                    // After it gets added to frontend
                    value={skill}
                    onChange={(e) => handleSectionChange('skills', skill.id, 'skills', e.target.value)}
                    placeholder="Kindly make use of commas to separate your skill"
                    rows="3" className={`${sectionInputClasses} w-full resize-y`}
                /> */}
                <div className="space-y-4">
                    <div className="flex items-center gap-2 border-b border-slate-100 pb-2">

                        {/* <h3 className="text-xl font-black text-slate-800 tracking-tight">Skills</h3> */}
                    </div>
                    <p className="text-sm text-slate-400 font-medium">Capture your expertise. Use commas to separate each skill.</p>
                    {/* <textarea
                        value={userDetails.skills}
                        onChange={(e) => setUserDetails({ ...userDetails, skills: e.target.value })}
                        placeholder="e.g. React, Project Management, Python, Public Speaking"
                        rows="3"
                        className={inputClasses + " resize-y min-h-[100px] border-dashed border-2"}
                    /> */}
                    <textarea
                        value={userDetails.skills || ''}
                        onChange={(e) => setUserDetails({ ...userDetails, skills: e.target.value })}
                        placeholder="e.g. React, Project Management, Python"
                        rows="3"
                        className={inputClasses + " resize-y min-h-[100px] border-dashed border-2"}
                    />

                    {/* <div className="flex flex-wrap gap-2 mt-2">
                        {userDetails.skills.split(',').filter(s => s.trim()).map((s, i) => (
                            <span key={i} className="px-3 py-1 bg-green-50 text-[#198754] text-xs font-bold rounded-full border border-green-100">
                                {s.trim()}
                            </span>
                        ))}
                    </div> */}
                    {/* At times, Users might not input anything for skills */}
                    <div className="flex flex-wrap gap-2 mt-2">
                        {(() => {
                            const skillsData = userDetails.skills;
                            let skillsArray = [];

                            if (Array.isArray(skillsData)) {
                                // If it's already an array, use it directly
                                skillsArray = skillsData;
                            } else if (typeof skillsData === 'string' && skillsData.trim() !== '') {
                                // If it's a string, split it
                                skillsArray = skillsData.split(',');
                            }

                            return skillsArray
                                .map(s => String(s).trim()) // Ensure every element is a trimmed string
                                .filter(s => s !== '')      // Remove empty strings
                                .map((skill, index) => (
                                    <span
                                        key={index}
                                        className="px-3 py-1 bg-green-50 text-[#198754] text-xs font-bold rounded-full border border-green-100"
                                    >
                                        {skill}
                                    </span>
                                ));
                        })()}
                    </div>

                </div>



                {/* 3. EDUCATION SECTION */}
                <h2 className="text-2xl font-bold mt-10 mb-4 text-gray-800 border-b pb-2">4. Education Background</h2>
                <div className="space-y-6">
                    {(userDetails.educations || []).map((edu) => (
                        <div key={edu.id} className="p-5 border border-gray-200 rounded-xl bg-gray-50 relative shadow-sm">
                            <button type="button" onClick={() => handleRemoveEntry('educations', edu.id)} className="absolute top-3 right-3 text-gray-400 hover:text-red-500 transition duration-150 p-1 rounded-full bg-white" title="Remove Education Entry">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm6 0a1 1 0 10-2 0v6a1 1 0 102 0V8z" clipRule="evenodd" /></svg>
                            </button>
                            <h3 className="text-lg font-semibold mb-3 text-gray-700">Study: {edu.degree || 'New Degree'}</h3>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                                <input type="text" value={edu.degree} onChange={(e) => handleSectionChange('educations', edu.id, 'degree', e.target.value)} placeholder="Degree" className={sectionInputClasses} required />
                                <input type="text" value={edu.institution} onChange={(e) => handleSectionChange('educations', edu.id, 'institution', e.target.value)} placeholder="Institution" className={sectionInputClasses} required />
                                <input type="text" value={edu.location} onChange={(e) => handleSectionChange('educations', edu.id, 'location', e.target.value)} placeholder="Location" className={sectionInputClasses} required />
                                <input type="text" value={edu.dates} onChange={(e) => handleSectionChange('educations', edu.id, 'dates', e.target.value)} placeholder="Dates (e.g., 2015 - 2019)" className={sectionInputClasses} required />
                            </div>
                            <textarea
                                value={edu.achievements}
                                onChange={(e) => handleSectionChange('educations', edu.id, 'achievements', e.target.value)}
                                placeholder="Achievements (as a single string (sentence), e.g., Graduated with First Class Honors)"
                                rows="3" className={`${sectionInputClasses} w-full resize-y`}
                            />
                        </div>
                    ))}
                    <button type="button" onClick={() => handleAddEntry('educations')} className={dashedButton}>
                        + Add Education Entry
                    </button>
                </div>

                {/* 4. PROJECTS SECTION */}
                <h2 className="text-2xl font-bold mt-10 mb-4 text-gray-800 border-b pb-2">5. Projects</h2>
                <div className="space-y-6">
                    {(userDetails.projects || []).map((proj) => (
                        <div key={proj.id} className="p-5 border border-gray-200 rounded-xl bg-gray-50 relative shadow-sm">
                            <button type="button" onClick={() => handleRemoveEntry('projects', proj.id)} className="absolute top-3 right-3 text-gray-400 hover:text-red-500 transition duration-150 p-1 rounded-full bg-white" title="Remove Project Entry">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm6 0a1 1 0 10-2 0v6a1 1 0 102 0V8z" clipRule="evenodd" /></svg>
                            </button>
                            <h3 className="text-lg font-semibold mb-3 text-gray-700">Project: {proj.name || 'New Project'}</h3>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                                <input type="text" value={proj.name} onChange={(e) => handleSectionChange('projects', proj.id, 'name', e.target.value)} placeholder="Project Name" className={sectionInputClasses} required />
                                <input type="url" value={proj.url} onChange={(e) => handleSectionChange('projects', proj.id, 'url', e.target.value)} placeholder="Project URL" className={sectionInputClasses} />
                                <input type="text" value={proj.dates} onChange={(e) => handleSectionChange('projects', proj.id, 'dates', e.target.value)} placeholder="Dates (e.g., July, 2022)" className={sectionInputClasses} required />
                                <span className="hidden sm:block"></span>
                            </div>
                            <textarea
                                value={proj.summary}
                                onChange={(e) => handleSectionChange('projects', proj.id, 'summary', e.target.value)}
                                placeholder="Project Summary"
                                rows="3" className={`${sectionInputClasses} w-full resize-y`} required
                            />
                        </div>
                    ))}
                    <button type="button" onClick={() => handleAddEntry('projects')} className={dashedButton}>
                        + Add Project Entry
                    </button>
                </div>

                {/* 5. CERTIFICATIONS SECTION */}
                <h2 className="text-2xl font-bold mt-10 mb-4 text-gray-800 border-b pb-2">6. Certifications</h2>
                <div className="space-y-6">
                    {(userDetails.certifications || []).map((cert) => (
                        <div key={cert.id} className="p-5 border border-gray-200 rounded-xl bg-gray-50 relative shadow-sm">
                            <button type="button" onClick={() => handleRemoveEntry('certifications', cert.id)} className="absolute top-3 right-3 text-gray-400 hover:text-red-500 transition duration-150 p-1 rounded-full bg-white" title="Remove Certification Entry">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm6 0a1 1 0 10-2 0v6a1 1 0 102 0V8z" clipRule="evenodd" /></svg>
                            </button>
                            {/* { console.log(cert) } */}
                            <h3 className="text-lg font-semibold mb-3 text-gray-700">Cert: {cert.name || 'New Certification'}</h3>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                                <input type="text" value={cert.name} onChange={(e) => handleSectionChange('certifications', cert.id, 'name', e.target.value)} placeholder="Name" className={sectionInputClasses} required />
                                <input type="text" value={cert.certificate_id} onChange={(e) => handleSectionChange('certifications', cert.id, 'certificate_id', e.target.value)} placeholder="Certificate ID" className={sectionInputClasses} />
                                <input type="url" value={cert.url} onChange={(e) => handleSectionChange('certifications', cert.id, 'url', e.target.value)} placeholder="Certificate URL" className={sectionInputClasses} />
                                <input type="date" value={cert.dates} onChange={(e) => handleSectionChange('certifications', cert.id, 'dates', e.target.value)} placeholder="Dates (e.g., 02/02/2023)" className={sectionInputClasses} required />
                                <input type="text" value={cert.issuing_organization} onChange={(e) => handleSectionChange('certifications', cert.id, 'issuing_organization', e.target.value)} placeholder="Issuing Organization" className={sectionInputClasses} required />
                                <span className="hidden sm:block"></span>
                            </div>
                            <textarea
                                value={cert.summary}
                                onChange={(e) => handleSectionChange('certifications', cert.id, 'summary', e.target.value)}
                                placeholder="Certificate Summary"
                                rows="3" className={`${sectionInputClasses} w-full resize-y`} required
                            />
                        </div>
                    ))}
                    <button type="button" onClick={() => handleAddEntry('certifications')} className={dashedButton}>
                        + Add Certification Entry
                    </button>
                </div>


                {/* FORM SUBMISSION */}
                <div className="flex flex-col items-center mt-10">
                    <button
                        type="submit"
                        className={`px-12 py-3 rounded-full font-bold text-white shadow-xl ${primaryColor}`}
                        disabled={formStatus === 'loading_edit'}
                    >
                        {buttonText}
                    </button>
                </div>
            </form>
        </div>
    );
};

// --- 3. TEMPLATE PREVIEW COMPONENTS ---

const SectionTitle = ({ children }) => (
    <h4 className="text-lg font-bold mt-4 mb-2 uppercase text-[#198754] border-b border-[#198754]/50 pb-1">{children}</h4>
);

// --- Template 1: Simple & Clean (Classic, Single-Column) ---
const SimpleTemplate = ({ userDetails }) => (
    <div className="p-8 space-y-4 text-gray-800 text-sm">
        <header className="text-center pb-4 border-b-4 border-gray-900">
            <h1 className="text-3xl font-extrabold text-gray-900">{userDetails.full_name}</h1>
            <p className="text-sm text-gray-600 space-x-3 mt-1">
                <span>{userDetails.phone}</span> |
                <span>{userDetails.email}</span> |
                <span>{userDetails.city}, {userDetails.country}</span>
            </p>
            <p className="text-sm text-gray-600 space-x-3 mt-1">
                {userDetails.linkedin_url && <a href={userDetails.linkedin_url} target="_blank" className="hover:underline">{userDetails.linkedin_url}</a>} |
                {userDetails.portfolio_url && <a href={userDetails.portfolio_url} target="_blank" className="hover:underline">{userDetails.portfolio_url}</a>}
            </p>
        </header>

        {/* Summary */}
        <SectionTitle>Professional Summary</SectionTitle>
        <p>{userDetails.professional_summary}</p>

        {/* Experience */}
        <SectionTitle>Work Experience</SectionTitle>
        {userDetails.work_experiences.map(exp => (
            <div key={exp.id} className="mb-4">
                <div className="flex justify-between font-semibold">
                    <span>{exp.job_title} at {exp.company}</span>
                    <span className="text-xs text-gray-500">{exp.dates} | {exp.location}</span>
                </div>
                <ListRenderer text={exp.responsibilities} />
            </div>
        ))}

        {/* Projects */}
        <SectionTitle>Key Projects</SectionTitle>
        {userDetails.projects.map(proj => (
            <div key={proj.id} className="mb-4">
                <div className="flex justify-between font-semibold">
                    <span>{proj.name}</span>
                    <span className="text-xs text-gray-500">{proj.dates}</span>
                </div>
                <p className="italic">{proj.summary}</p>
                {proj.url && <a href={proj.url} target="_blank" className="text-xs text-[#198754] hover:underline">{proj.url}</a>}
            </div>
        ))}

        {/* Education */}
        <SectionTitle>Education</SectionTitle>
        {userDetails.educations.map(edu => (
            <div key={edu.id} className="mb-4">
                <div className="flex justify-between font-semibold">
                    <span>{edu.degree}, {edu.institution}</span>
                    <span className="text-xs text-gray-500">{edu.dates} | {edu.location}</span>
                </div>
                {edu.achievements && <p className="text-sm italic mt-1">{edu.achievements}</p>}
            </div>
        ))}

        {/* Certifications */}
        <SectionTitle>Certifications</SectionTitle>
        <ul className="grid grid-cols-2 gap-x-4">
            {userDetails.certifications.map(cert => (
                <li key={cert.id} className="mb-2">
                    <span className="font-semibold">{cert.name}</span> <span className="text-xs text-gray-500">({cert.dates})</span>
                    <p className="text-xs italic">{cert.issuing_organization}</p>
                </li>
            ))}
        </ul>
    </div>
);

// --- Template 2: ATS Optimized (Plain Structure) ---
const ATSTemplate = ({ userDetails }) => (
    <div className="md:w-full sm:w-full p-8 space-y-6 font-mono text-gray-800 text-sm">
        <header className="text-center space-y-1">
            <h1 className="text-2xl font-bold uppercase">{userDetails.full_name}</h1>
            <p className="text-xs uppercase space-x-2 border-b border-gray-400 pb-2">
                <span>{userDetails.phone}</span> |
                <span>{userDetails.email}</span> |
                <span>{userDetails.city}, {userDetails.country}</span> |
                <span>{userDetails.linkedin_url}</span> |
                <span>{userDetails.portfolio_url}</span>
            </p>
        </header>

        {/* Summary */}
        <h2 className="text-lg font-bold uppercase border-b border-gray-800 pb-1">Summary</h2>
        <p>{userDetails.professional_summary}</p>

        {/* Experience */}
        <h2 className="text-lg font-bold uppercase border-b border-gray-800 pb-1">Experience</h2>
        {userDetails.work_experiences.map(exp => (
            <div key={exp.id} className="mb-4">
                <div className="flex justify-between font-bold">
                    <span>{exp.job_title} - {exp.company}</span>
                    <span className="text-xs">{exp.dates}</span>
                </div>
                <p className="text-xs mb-1">{exp.location}</p>
                <ListRenderer text={exp.responsibilities} />
            </div>
        ))}

        {/* Projects */}
        <h2 className="text-lg font-bold uppercase border-b border-gray-800 pb-1">Projects</h2>
        {userDetails.projects.map(proj => (
            <div key={proj.id} className="mb-4">
                <div className="flex justify-between font-bold">
                    <span>{proj.name}</span>
                    <span className="text-xs">{proj.dates}</span>
                </div>
                <p className="text-sm">{proj.summary}</p>
                {proj.url && <p className="text-xs">URL: {proj.url}</p>}
            </div>
        ))}

        {/* Education */}
        <h2 className="text-lg font-bold uppercase border-b border-gray-800 pb-1">Education</h2>
        {userDetails.educations.map(edu => (
            <div key={edu.id} className="mb-4">
                <div className="flex justify-between font-bold">
                    <span>{edu.degree}, {edu.institution}</span>
                    <span className="text-xs">{edu.dates}</span>
                </div>
                <p className="text-xs">{edu.location}</p>
                {edu.achievements && <p className="text-sm">{edu.achievements}</p>}
            </div>
        ))}

        {/* Certifications */}
        <h2 className="text-lg font-bold uppercase border-b border-gray-800 pb-1">Certifications</h2>
        <div className="space-y-2">
            {userDetails.certifications.map(cert => (
                <div key={cert.id} className="text-sm">
                    <span className="font-bold">{cert.name}</span> ({cert.dates})
                    <span className="mx-2">|</span> {cert.issuing_organization}
                </div>
            ))}
        </div>
    </div>
);

// --- Template 3: Modern & Bold (Two-Column) ---
const ModernTemplate = ({ userDetails }) => (
    <div className="grid grid-cols-4 h-full text-gray-800 text-sm">
        {/* Left Sidebar (25%) */}
        <div className="col-span-1 bg-gray-900 text-white p-6 space-y-6">
            <div className="text-center">
                <h1 className="text-2xl font-extrabold">{userDetails.full_name.split(' ')[0]}</h1>
                <h1 className="text-2xl font-extrabold -mt-1">{userDetails.full_name.split(' ').slice(1).join(' ')}</h1>
                <p className="text-xs font-light text-[#198754] uppercase tracking-wider mt-1">{userDetails.title}</p>
            </div>

            <div className="space-y-3">
                <h3 className="text-xs font-bold uppercase tracking-widest border-b border-gray-600 pb-1 text-[#198754]">Contact</h3>
                <div className="text-xs space-y-1">
                    <p>{userDetails.phone}</p>
                    <p>{userDetails.email}</p>
                    <p>{userDetails.city}, {userDetails.country}</p>
                    <p>{userDetails.home_address}</p>
                </div>
            </div>

            <div className="space-y-3">
                <h3 className="text-xs font-bold uppercase tracking-widest border-b border-gray-600 pb-1 text-[#198754]">Links</h3>
                <div className="text-xs space-y-1">
                    {userDetails.linkedin_url && <a href={userDetails.linkedin_url} target="_blank" className="hover:underline block">{userDetails.linkedin_url}</a>}
                    {userDetails.portfolio_url && <a href={userDetails.portfolio_url} target="_blank" className="hover:underline block">{userDetails.portfolio_url}</a>}
                </div>
            </div>

            <div className="space-y-3">
                <h3 className="text-xs font-bold uppercase tracking-widest border-b border-gray-600 pb-1 text-[#198754]">Certifications</h3>
                <div className="text-xs space-y-2">
                    {userDetails.certifications.map(cert => (
                        <div key={cert.id}>
                            <p className="font-semibold">{cert.name}</p>
                            <p className="text-gray-400 italic">{cert.issuing_organization}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>

        {/* Right Content (75%) */}
        <div className="col-span-3 p-6 space-y-6">

            {/* Summary */}
            <div className="pb-3 border-b border-gray-300">
                <h3 className="text-xl font-extrabold mb-1 uppercase text-gray-700">Profile Summary</h3>
                <p className="text-sm">{userDetails.professional_summary}</p>
            </div>

            {/* Experience */}
            <div className="pb-3 border-b border-gray-300">
                <h3 className="text-xl font-extrabold mb-3 uppercase text-gray-700">Experience</h3>
                {userDetails.work_experiences.map(exp => (
                    <div key={exp.id} className="mb-4">
                        <div className="flex justify-between items-baseline">
                            <h4 className="font-bold text-base text-[#198754]">{exp.job_title}</h4>
                            <span className="text-xs font-medium">{exp.dates}</span>
                        </div>
                        <p className="text-sm italic">{exp.company} | {exp.location}</p>
                        <ListRenderer text={exp.responsibilities} />
                    </div>
                ))}
            </div>

            {/* Projects */}
            <div className="pb-3 border-b border-gray-300">
                <h3 className="text-xl font-extrabold mb-3 uppercase text-gray-700">Projects</h3>
                {userDetails.projects.map(proj => (
                    <div key={proj.id} className="mb-4">
                        <div className="flex justify-between items-baseline">
                            <h4 className="font-bold text-base text-gray-700">{proj.name}</h4>
                            <span className="text-xs font-medium">{proj.dates}</span>
                        </div>
                        <p className="text-sm">{proj.summary}</p>
                        {proj.url && <a href={proj.url} target="_blank" className="text-xs text-[#198754] hover:underline">Link</a>}
                    </div>
                ))}
            </div>

            {/* Education */}
            <div className="pb-3">
                <h3 className="text-xl font-extrabold mb-3 uppercase text-gray-700">Education</h3>
                {userDetails.educations.map(edu => (
                    <div key={edu.id} className="mb-4">
                        <div className="flex justify-between items-baseline">
                            <h4 className="font-bold text-base text-gray-700">{edu.degree}</h4>
                            <span className="text-xs font-medium">{edu.dates}</span>
                        </div>
                        <p className="text-sm italic">{edu.institution} | {edu.location}</p>
                        {edu.achievements && <p className="text-xs mt-1">{edu.achievements}</p>}
                    </div>
                ))}
            </div>
        </div>
    </div>
);

// Template 4: Creative & COlorful

const CreativeColorfulTemplate = ({ userDetails }) => (
    <div className="flex flex-col md:flex-row min-h-screen bg-white font-sans text-gray-800">
        {/* Sidebar: Colorful & Details */}
        <aside className="w-full md:w-1/3 bg-gradient-to-b from-pink-500 via-purple-600 to-indigo-700 text-white p-8">
            <div className="mb-10">
                <h1 className="text-4xl font-black uppercase leading-tight tracking-tighter">
                    {userDetails.full_name}
                </h1>
                <p className="text-pink-200 font-medium tracking-widest uppercase text-sm mt-2">
                    {userDetails.job_title}
                </p>
            </div>

            {/* Details Section */}
            <section className="mb-10">
                <h2 className="text-lg font-bold border-b-2 border-pink-400 pb-1 mb-4 uppercase">Details</h2>
                <div className="space-y-3 text-sm font-light">
                    <p className="flex flex-col">
                        <span className="font-bold text-[10px] uppercase opacity-70">Email</span>
                        {userDetails.email}
                    </p>
                    <p className="flex flex-col">
                        <span className="font-bold text-[10px] uppercase opacity-70">Phone</span>
                        {userDetails.phone}
                    </p>
                    <p className="flex flex-col leading-relaxed">
                        <span className="font-bold text-[10px] uppercase opacity-70">Address</span>
                        {userDetails.address}
                    </p>
                </div>
            </section>

            {/* Skills Section */}
            <section>
                <h2 className="text-lg font-bold border-b-2 border-pink-400 pb-1 mb-4 uppercase">Skills</h2>
                <div className="flex flex-wrap gap-2">
                    {userDetails.skills.map((skill, index) => (
                        <span
                            key={index}
                            className="bg-white/20 backdrop-blur-md px-3 py-1 rounded-md text-xs font-medium border border-white/30"
                        >
                            {skill}
                        </span>
                    ))}
                </div>
            </section>
        </aside>

        {/* Main Content: Experience & Education */}
        <main className="w-full md:w-2/3 p-10 space-y-10">
            {/* Experience Section */}
            <section>
                <h2 className="text-2xl font-black text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-500 uppercase mb-6 italic">
                    Experience
                </h2>
                <div className="space-y-8">
                    {userDetails.work_experiences.map((exp, index) => (
                        <div key={index} className="relative pl-6 border-l-2 border-purple-100">
                            <div className="absolute w-3 h-3 bg-pink-500 rounded-full -left-[7px] top-1.5 shadow-[0_0_10px_rgba(236,72,153,0.5)]"></div>
                            <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-2">
                                <h3 className="text-lg font-bold text-gray-900">{exp.job_title}</h3>
                                <span className="text-xs font-bold text-purple-600 bg-purple-50 px-2 py-1 rounded">
                                    {exp.dates}
                                </span>
                            </div>
                            <p className="text-sm font-semibold text-indigo-600 mb-3">{exp.company}</p>
                            <div className="text-gray-600">
                                <ListRenderer text={exp.responsibilities} />
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* Education Section */}
            <section>
                <h2 className="text-2xl font-black text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-purple-500 uppercase mb-6 italic">
                    Education
                </h2>
                <div className="grid grid-cols-1 gap-6">
                    {userDetails.educations.map((edu, index) => (
                        <div key={index} className="bg-gray-50 p-4 rounded-xl border-l-4 border-indigo-500">
                            <div className="flex justify-between items-start">
                                <h3 className="font-bold text-gray-900">{edu.degree}</h3>
                                <span className="text-[10px] font-bold uppercase text-gray-400 tracking-tighter">{edu.dates}</span>
                            </div>
                            <p className="text-sm text-indigo-600 mb-2">{edu.institution}</p>
                            <p className="text-xs text-gray-500 leading-relaxed italic">{edu.achievements}</p>
                        </div>
                    ))}
                </div>
            </section>
        </main>
    </div>
);

const MinimalistSleekTemplate = ({ userDetails }) => (
    <div className="max-w-4xl mx-auto p-12 bg-white text-slate-900 font-sans leading-relaxed">
        {/* Header Section */}
        <header className="border-b-2 border-gray-100 pb-8 mb-8">
            <h1 className="text-5xl font-light tracking-tighter text-gray-900 mb-2">
                {userDetails.full_name.split(' ')[0]} <span className="font-bold">{userDetails.full_name.split(' ')[1]}</span>
            </h1>
            <p className="text-xl text-gray-500 font-medium tracking-wide uppercase italic">
                {userDetails.job_title}
            </p>
        </header>

        <div className="grid grid-cols-12 gap-12">
            {/* Left Column: Experience and Education */}
            <div className="col-span-8 space-y-10">

                {/* Experience */}
                <section>
                    <h2 className="text-sm font-black uppercase tracking-[0.2em] text-gray-400 mb-6">Experience</h2>
                    <div className="space-y-8">
                        {userDetails.work_experiences.map((exp, index) => (
                            <div key={index} className="group">
                                <div className="flex justify-between items-baseline mb-1">
                                    <h3 className="text-lg font-bold text-gray-800">{exp.job_title}, {exp.company.split(',')[0]}</h3>
                                    <span className="text-xs font-mono text-gray-400 uppercase tracking-tighter">{exp.dates} </span>
                                </div>
                                <p className="text-xs text-indigo-500 font-medium mb-3 uppercase tracking-wider">{exp.location || exp.company.split(',').slice(1).join(',')}</p>
                                <div className="text-sm">
                                    <ListRenderer text={exp.responsibilities} />
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                {/* Education */}
                <section>
                    <h2 className="text-sm font-black uppercase tracking-[0.2em] text-gray-400 mb-6">Education</h2>
                    <div className="space-y-6">
                        {userDetails.educations.map((edu, index) => (
                            <div key={index}>
                                <div className="flex justify-between items-baseline">
                                    <h3 className="font-bold text-gray-800">{edu.institution}, {edu.degree} </h3>
                                    <span className="text-xs font-mono text-gray-400 uppercase tracking-tighter italic">{edu.dates || "Graduated"}</span>
                                </div>
                                <p className="text-sm text-gray-600 mt-1">{edu.achievements} </p>
                            </div>
                        ))}
                    </div>
                </section>
            </div>

            {/* Right Column: Details and Skills */}
            <div className="col-span-4 space-y-10">

                {/* Contact Details */}
                <section className="bg-gray-50 p-6 rounded-lg">
                    <h2 className="text-sm font-black uppercase tracking-[0.2em] text-gray-400 mb-4 text-center">Details </h2>
                    <div className="space-y-4 text-sm">
                        <div>
                            <span className="block font-bold uppercase text-[10px] text-gray-400 tracking-widest">Address </span>
                            <p className="text-gray-700">{userDetails.address}</p>
                        </div>
                        <div>
                            <span className="block font-bold uppercase text-[10px] text-gray-400 tracking-widest">Phone </span>
                            <p className="text-gray-700">{userDetails.phone}</p>
                        </div>
                        <div>
                            <span className="block font-bold uppercase text-[10px] text-gray-400 tracking-widest">Email </span>
                            <p className="text-gray-700 break-all">{userDetails.email}</p>
                        </div>
                    </div>
                </section>

                {/* Skills */}
                <section>
                    <h2 className="text-sm font-black uppercase tracking-[0.2em] text-gray-400 mb-4">Skills</h2>
                    <div className="flex flex-col gap-2">
                        {userDetails.skills.map((skill, index) => (
                            <div key={index} className="flex items-center justify-between group">
                                <span className="text-sm font-medium text-gray-700">{skill} </span>
                                <div className="h-1 w-12 bg-gray-100 rounded-full overflow-hidden">
                                    <div className="h-full bg-gray-400 w-full group-hover:bg-indigo-400 transition-colors"></div>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>
            </div>
        </div>
    </div>
);

const ClassicTimelessTemplate = ({ userDetails }) => (
    <div className="max-w-4xl mx-auto p-12 bg-white text-gray-900 font-serif leading-normal shadow-sm">
        {/* Header Section */}
        <header className="text-center mb-8">
            <h1 className="text-3xl font-bold uppercase tracking-wide border-b-2 border-gray-900 inline-block mb-2">
                {userDetails.full_name}
            </h1>
            <p className="text-lg font-medium text-gray-700 mb-4 tracking-tight">
                {userDetails.job_title}
            </p>
            <div className="text-sm text-gray-600 space-x-3 italic">
                <span>{userDetails.address}</span>
                <span>{userDetails.phone}</span> |
                <span>{userDetails.email}</span>
            </div>
        </header>

        <div className="space-y-8">
            {/* Experience Section */}
            <section>
                <h2 className="text-lg font-bold uppercase border-b border-gray-300 mb-4 tracking-widest">
                    Experience
                </h2>
                <div className="space-y-6">
                    {userDetails.work_experiences.map((exp, index) => (
                        <div key={index}>
                            <div className="flex justify-between font-bold text-gray-800">
                                <span>{exp.job_title}, {exp.company}</span>
                                <span className="uppercase text-xs">{exp.dates}</span>
                            </div>
                            <div className="mt-2 text-sm leading-relaxed">
                                <ListRenderer text={exp.responsibilities} />
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* Education Section */}
            <section>
                <h2 className="text-lg font-bold uppercase border-b border-gray-300 mb-4 tracking-widest">
                    Education
                </h2>
                <div className="space-y-4">
                    {userDetails.educations.map((edu, index) => (
                        <div key={index}>
                            <div className="flex justify-between font-bold text-gray-800">
                                <span>{edu.degree}, {edu.institution}</span>
                                <span className="uppercase text-xs">Graduated</span>
                            </div>
                            <p className="text-sm text-gray-600 mt-1 italic">{edu.achievements}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* Skills Section */}
            <section>
                <h2 className="text-lg font-bold uppercase border-b border-gray-300 mb-4 tracking-widest">
                    Skills
                </h2>
                <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm">
                    {userDetails.skills.map((skill, index) => (
                        <div key={index} className="flex items-center">
                            <span className="font-bold mr-2">▪</span>
                            <span className="text-gray-700 uppercase tracking-tight">{skill}</span>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    </div>
);

const BoldDynamicTemplate = ({ userDetails }) => (
    <div className="max-w-4xl mx-auto bg-white shadow-lg overflow-hidden font-sans border border-gray-200">
        {/* High Impact Header */}
        <header className="bg-slate-900 text-white p-10">
            <h1 className="text-5xl font-black uppercase tracking-tighter mb-2">
                {userDetails.full_name}
            </h1>
            <p className="text-xl text-blue-400 font-bold uppercase tracking-widest mb-6">
                {userDetails.job_title}
            </p>
            <div className="flex flex-wrap gap-y-2 gap-x-6 text-sm font-medium opacity-90">
                <span className="flex items-center">
                    <span className="text-blue-400 mr-2">📍</span> {userDetails.address}
                </span>
                <span className="flex items-center">
                    <span className="text-blue-400 mr-2">📞</span> {userDetails.phone}
                </span>
                <span className="flex items-center">
                    <span className="text-blue-400 mr-2">✉️</span> {userDetails.email}
                </span>
            </div>
        </header>

        <div className="p-10 grid grid-cols-12 gap-10">
            {/* Main Content (Left) */}
            <div className="col-span-8 space-y-10">
                {/* Experience */}
                <section>
                    <div className="flex items-center mb-6">
                        <h2 className="text-2xl font-black uppercase tracking-tight text-slate-900">Experience</h2>
                        <div className="flex-grow h-1 bg-slate-100 ml-4"></div>
                    </div>
                    <div className="space-y-8">
                        {userDetails.work_experiences.map((exp, index) => (
                            <div key={index} className="relative">
                                <div className="flex justify-between items-start mb-1">
                                    <h3 className="text-lg font-bold text-slate-800">{exp.job_title}</h3>
                                    <span className="bg-blue-50 text-blue-700 px-3 py-1 rounded-full text-xs font-bold whitespace-nowrap">
                                        {exp.dates}
                                    </span>
                                </div>
                                <p className="text-md font-bold text-blue-600 mb-2">{exp.company}</p>
                                <ListRenderer text={exp.responsibilities} />
                            </div>
                        ))}
                    </div>
                </section>

                {/* Education */}
                <section>
                    <div className="flex items-center mb-6">
                        <h2 className="text-2xl font-black uppercase tracking-tight text-slate-900">Education</h2>
                        <div className="flex-grow h-1 bg-slate-100 ml-4"></div>
                    </div>
                    <div className="space-y-6">
                        {userDetails.educations.map((edu, index) => (
                            <div key={index} className="bg-slate-50 p-5 rounded-lg border-l-4 border-slate-900">
                                <h3 className="text-lg font-bold text-slate-800">{edu.degree}</h3>
                                <p className="text-blue-600 font-bold text-sm mb-2">{edu.institution}</p>
                                <p className="text-sm text-gray-600 leading-relaxed italic">{edu.achievements}</p>
                            </div>
                        ))}
                    </div>
                </section>
            </div>

            {/* Sidebar Content (Right) */}
            <div className="col-span-4">
                <section className="bg-slate-900 text-white p-6 rounded-2xl">
                    <h2 className="text-xl font-black uppercase tracking-tight mb-6 text-blue-400 text-center">Skills</h2>
                    <div className="flex flex-wrap gap-2">
                        {/* {userDetails.skills.map((skill, index) => (
              <span 
                key={index} 
                className="bg-slate-800 border border-slate-700 px-4 py-2 rounded-xl text-xs font-bold uppercase tracking-wider block w-full text-center hover:bg-blue-600 transition-colors cursor-default"
              >
                {skill}
              </span>
            ))} */}
                    </div>
                </section>
            </div>
        </div>
    </div>
);

const ElegantRefinedTemplate = ({ userDetails }) => (
    <div className="max-w-4xl mx-auto min-h-[1100px] bg-[#f0f7f4] flex flex-col md:flex-row shadow-lg font-sans">

        {/* Left Sidebar - Exact Light Green Background */}
        <aside className="w-full md:w-[35%] p-8 bg-[#f0f7f4]">
            {/* Name Section */}
            <div className="mb-12">
                <h1 className="text-4xl font-light text-gray-800 tracking-tight leading-none uppercase">
                    {userDetails.full_name.split(' ')[0]}
                </h1>
                <h1 className="text-4xl font-bold text-gray-800 tracking-tight leading-none uppercase">
                    {userDetails.full_name.split(' ')[1]}
                </h1>
            </div>

            {/* Details Section */}
            <section className="mb-10 bg-[#f0f7f4]">
                <h2 className="text-lg font-bold border-b border-gray-300 pb-1 mb-4 uppercase tracking-wider text-gray-700">
                    Details
                </h2>
                <div className="space-y-4 text-sm">
                    <div>
                        <p className="font-bold text-gray-800">Phone</p>
                        <p className="text-gray-600">{userDetails.phone}</p>
                    </div>
                    <div>
                        <p className="font-bold text-gray-800">Email</p>
                        <p className="text-gray-600 break-all">{userDetails.email}</p>
                    </div>
                    <div>
                        <p className="font-bold text-gray-800">Location</p>
                        <p className="text-gray-600 leading-relaxed">{userDetails.address}</p>
                    </div>
                </div>
            </section>

            {/* Skills Section */}
            <section>
                <h2 className="text-lg font-bold border-b border-gray-300 pb-1 mb-4 uppercase tracking-wider text-gray-700">
                    Skills
                </h2>
                <div className="space-y-2">
                    {userDetails.skills.map((skill, index) => (
                        <div key={index} className="text-[13px] font-medium text-gray-700 bg-white/50 px-3 py-1.5 rounded shadow-sm">
                            {skill}
                        </div>
                    ))}
                </div>
            </section>
        </aside>

        <main className="w-full md:w-[65%] p-10 bg-[#f0f7f4]">
            {/* Job Title Header */}
            <div className="mb-10">
                <h2 className="text-xl font-medium tracking-[0.15em] text-gray-500 uppercase">
                    {userDetails.job_title}
                </h2>
            </div>

            {/* Experience Section */}
            <section className="mb-12">
                <h2 className="text-2xl font-bold text-gray-800 mb-6 uppercase border-b-2 border-gray-100 pb-2">
                    Experience
                </h2>
                <div className="space-y-8">
                    {userDetails.work_experiences.map((exp, index) => (
                        <div key={index}>
                            <div className="flex justify-between items-baseline mb-1">
                                <span className="text-xs font-bold text-gray-400 uppercase tracking-tighter">
                                    {exp.dates}
                                </span>
                                <span className="text-xs font-bold text-gray-800 italic uppercase">
                                    {exp.company}
                                </span>
                            </div>
                            <h3 className="text-lg font-bold text-gray-800">
                                {exp.job_title}, {exp.location || "San Francisco, CA, USA"}
                            </h3>
                            <ListRenderer text={exp.responsibilities} />
                        </div>
                    ))}
                </div>
            </section>

            {/* Education Section */}
            <section>
                <h2 className="text-2xl font-bold text-gray-800 mb-6 uppercase border-b-2 border-gray-100 pb-2">
                    Education
                </h2>
                <div className="space-y-6">
                    {userDetails.educations.map((edu, index) => (
                        <div key={index}>
                            <h3 className="text-md font-bold text-gray-800">
                                {edu.degree}, {edu.institution}
                            </h3>
                            <p className="text-sm text-gray-600 mt-1 leading-relaxed">
                                {edu.achievements}
                            </p>
                        </div>
                    ))}
                </div>
            </section>
        </main>
    </div>
);

const VibrantEnergeticTemplate = ({ userDetails }) => (
    <div className="max-w-4xl mx-auto bg-white shadow-xl font-sans text-gray-900 border border-gray-100">
        {/* Header Section */}
        <header className="p-10 border-b-8 border-black">
            <p className="text-sm font-black tracking-[0.4em] uppercase text-gray-500 mb-2">
                {userDetails.job_title}
            </p>
            <h1 className="text-6xl font-black uppercase tracking-tighter mb-6 leading-none">
                {userDetails.full_name}
            </h1>
            <div className="text-[11px] font-bold uppercase tracking-widest text-gray-400 flex flex-wrap gap-4">
                <span>{userDetails.address}</span>
                <span>|</span>
                <span>{userDetails.phone}</span>
                <span>|</span>
                <span>{userDetails.email}</span>
            </div>
        </header>

        <div className="p-10 grid grid-cols-12 gap-12">
            {/* Left Column - Skills */}
            <aside className="col-span-4">
                <h2 className="text-xl font-black uppercase tracking-widest mb-6 border-b-4 border-black pb-2">
                    Skills
                </h2>
                <div className="flex flex-col gap-3">
                    {/* {userDetails.skills.map((skill, index) => (
            <div key={index} className="flex items-center justify-between group">
              <span className="text-sm font-bold uppercase tracking-wider text-gray-700">
                {skill}
              </span>
              <div className="h-2 w-8 bg-black"></div>
            </div>
          ))} */}
                </div>
            </aside>

            {/* Right Column - Experience & Education */}
            <main className="col-span-8 space-y-12">
                {/* Experience Section */}
                <section>
                    <h2 className="text-xl font-black uppercase tracking-widest mb-8 border-b-4 border-black pb-2">
                        Experience
                    </h2>
                    <div className="space-y-10">
                        {userDetails.work_experiences.map((exp, index) => (
                            <div key={index}>
                                <p className="text-[10px] font-black uppercase text-gray-400 mb-2 tracking-widest">
                                    {exp.dates}
                                </p>
                                <div className="flex flex-col mb-3">
                                    <h3 className="text-lg font-black uppercase tracking-tight">
                                        {exp.job_title}
                                    </h3>
                                    <p className="text-sm font-bold text-gray-500 italic">
                                        {exp.company}
                                    </p>
                                </div>
                                <ListRenderer text={exp.responsibilities} />
                            </div>
                        ))}
                    </div>
                </section>

                {/* Education Section */}
                <section>
                    <h2 className="text-xl font-black uppercase tracking-widest mb-8 border-b-4 border-black pb-2">
                        Education
                    </h2>
                    <div className="space-y-8">
                        {userDetails.educations.map((edu, index) => (
                            <div key={index}>
                                <h3 className="text-md font-black uppercase tracking-tight mb-1">
                                    {edu.degree}
                                </h3>
                                <p className="text-sm font-bold text-gray-500 mb-2">
                                    {edu.institution}
                                </p>
                                <p className="text-xs text-gray-600 leading-relaxed font-medium">
                                    {edu.achievements}
                                </p>
                            </div>
                        ))}
                    </div>
                </section>
            </main>
        </div>
    </div>
);

const FuturisticTechSavvyTemplate = ({ userDetails }) => (
    <div className="max-w-[850px] mx-auto bg-white min-h-[1100px] shadow-lg font-sans text-gray-900 overflow-hidden">
        {/* Header Section with Signature Centered Styling */}
        <header className="pt-16 pb-12 text-center">
            <h1 className="text-5xl font-medium tracking-[0.05em] text-gray-900 mb-6 uppercase">
                {userDetails.full_name}
            </h1>

            {/* Centered Double Line Job Title */}
            <div className="relative flex flex-col items-center">
                <div className="w-full border-t border-black mb-1.5"></div>
                <p className="text-[16px] tracking-[0.25em] text-gray-700 uppercase font-normal py-1">
                    {userDetails.job_title}
                </p>
                <div className="w-full border-t border-black mt-1.5"></div>
            </div>
        </header>

        <div className="px-12 py-4 grid grid-cols-12 gap-16">
            {/* Sidebar - Contact & Skills */}
            <aside className="col-span-4 space-y-16">
                {/* Contact Info */}
                <section className="text-[15px] space-y-3 text-gray-800 font-light">
                    <p className="tracking-tight">{userDetails.phone}</p>
                    <p className="break-all tracking-tight">{userDetails.email}</p>
                    <p className="leading-relaxed tracking-tight">
                        {userDetails.address}
                    </p>
                </section>

                {/* Skills with Rating Indicator */}
                <section>
                    <h2 className="text-[20px] font-bold uppercase tracking-widest mb-2 border-b-2 border-black inline-block">
                        Skills
                    </h2>
                    <div className="mt-6 space-y-5">
                        {/* {userDetails.skills.map((skill, index) => (
              <div key={index} className="space-y-1">
                <p className="text-[16px] font-normal text-gray-900">{skill}</p>
                <div className="flex gap-1.5 text-[11px] text-black">
                  <span>♦</span><span>♦</span><span>♦</span><span>♦</span><span>♦</span>
                </div>
              </div>
            ))} */}
                    </div>
                </section>
            </aside>

            {/* Main Content Area */}
            <main className="col-span-8 space-y-14">
                {/* Experience Section */}
                <section>
                    <h2 className="text-[20px] font-bold uppercase tracking-widest mb-6 border-b-2 border-black inline-block">
                        Experience
                    </h2>
                    <div className="space-y-10">
                        {userDetails.work_experiences.map((exp, index) => (
                            <div key={index} className="space-y-1">
                                <h3 className="text-[17px] font-medium text-gray-900">
                                    {exp.job_title}, <span className="font-light">{exp.company}</span>
                                </h3>
                                <p className="text-[15px] font-bold text-gray-900 mt-1 mb-2">
                                    {exp.dates}
                                </p>
                                <div className="mt-2 pl-1">
                                    <ListRenderer text={exp.responsibilities} />
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                {/* Education Section */}
                <section>
                    <h2 className="text-[20px] font-bold uppercase tracking-widest mb-6 border-b-2 border-black inline-block">
                        Education
                    </h2>
                    <div className="space-y-8">
                        {userDetails.educations.map((edu, index) => (
                            <div key={index} className="space-y-2">
                                <h3 className="text-[16px] font-medium text-gray-900">
                                    {edu.institution}, <span className="italic font-light">{edu.degree}</span>
                                </h3>
                                <p className="text-[14px] text-gray-700 leading-relaxed font-light">
                                    {edu.achievements}
                                </p>
                            </div>
                        ))}
                    </div>
                </section>
            </main>
        </div>
    </div>
);

const userDetails = {
    full_name: "IBK Obas",
    job_title: "Software Engineer 2",
    email: localStorage.getItem('user_email'),
    phone: "+1234567890",
    address: "123 Market St, 94103 San Francisco, United States America",
    skills: ["Python", "JavaScript", "React", "Node.js", "SQL"],
    work_experiences: [
        {
            job_title: "Frontend Developer",
            company: "TechCorp Inc., San Francisco, CA, USA",
            dates: "Jan 2020 - Aug 2024",
            responsibilities: "• Developed and maintained React-based web applications.\n• Collaborated with designers and backend engineers.\n• Improved performance by 40% through code optimization."
        },
        {
            job_title: "Backend Developer",
            company: "DataSolutions LLC, San Francisco, CA, USA",
            dates: "Sep 2018 - Dec 2019",
            responsibilities: "• Built REST APIs in Python and Node.js.\n• Managed database schemas and optimized queries.\n• Implemented authentication and authorization features."
        }
    ],
    educations: [
        {
            degree: "M.Sc. in Data Science",
            institution: "Stanford University, Stanford",
            dates: "Graduated",
            achievements: "Focus on machine learning and Al. Thesis on predictive analytics."
        },
        {
            degree: "B.Sc. in Computer Science",
            institution: "University of California, Berkeley, Berkeley",
            dates: "Graduated",
            achievements: "Graduated with Honors. Specialized in software engineering and machine learning."
        }
    ]
};


// --- 4. STEP 2: TEMPLATE SELECTION AND CV CREATION (LIVE API Call) ---

// const API_BASE_URL = 'https://test.signup.com.ng/v1/api'; 
const API_BASE_URL = 'https://cv.signup.com.ng/v1/api';
const CV_CREATE_ENDPOINT = `${API_BASE_URL}/cvs`;

const CVTemplatesPage = ({ navigate }) => {
    const { userDetails, setUserDetails } = useCVContext();
    const [selectedTemplate, setSelectedTemplate] = useState(userDetails.template_id || 3);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoading2, setIsLoading2] = useState(false);
    const [statusMessage, setStatusMessage] = useState(null);

    const [templates, setTemplates] = useState([]);
    const [loadingTemplates, setLoadingTemplates] = useState(true);


    const { auth } = useAuth()
    const API_TOKEN = auth.token

    // const selectTemplate = (id) => {
    //     setUserDetails(prev => ({
    //         ...prev,
    //         template_id: id
    //     }));
    //    navigate(4)
    // };

    const selectTemplate = (id) => {
        setSelectedTemplate(id);
    };

    useEffect(() => {
        const fetchTemplates = async () => {
            try {
                const res = await fetch('https://cv.signup.com.ng/v1/api/templates');
                const data = await res.json();

                if (data.status === "success") {
                    setTemplates(data.data);
                }
            } catch (err) {
                console.error("Failed to fetch templates:", err);
            } finally {
                setLoadingTemplates(false);
            }
        };

        fetchTemplates();
    }, []);

    const getThumbnailUrl = (pdfUrl) => {
        return pdfUrl
            .replace('/upload/', '/upload/w_600,c_fit/')
            .replace('.pdf', '.jpg');
    };

    // Update context when a template is selected
    useEffect(() => {
        setUserDetails(prev => ({ ...prev, template_id: selectedTemplate }));
    }, [selectedTemplate, setUserDetails]);

    // Determine which Template component to render
    const renderTemplatePreview = () => {
        const template = templates.find(t => t.id === selectedTemplate);
        if (!template) return <p className='p-8 text-center text-red-500'>Template not found.</p>;

        switch (template.type) {
            case 'Simple':
                return <SimpleTemplate userDetails={userDetails} />;
            case 'ATS':
                return <ATSTemplate userDetails={userDetails} />;
            case 'CreativeColorful':
                return <CreativeColorfulTemplate userDetails={userDetails} />;
            case 'MinimalistSleek':
                return <MinimalistSleekTemplate userDetails={userDetails} />;
            case 'ClassicTimeless':
                return <ClassicTimelessTemplate userDetails={userDetails} />;
            case 'BoldDynamic':
                return <BoldDynamicTemplate userDetails={userDetails} />;
            case 'ElegantRefined':
                return <ElegantRefinedTemplate userDetails={userDetails} />;
            case 'VibrantEnergetic':
                return <VibrantEnergeticTemplate userDetails={userDetails} />;
            case 'FuturisticTechSavvy':
                return <FuturisticTechSavvyTemplate userDetails={userDetails} />;
            case 'Modern':
            default:
                return <ModernTemplate userDetails={userDetails} />;
        }
    }

    // Handler to construct API payload and perform LIVE fetch request
    const handleCreateCV = async () => {
        const API_TOKEN = auth.token
        setIsLoading(true);
        setStatusMessage(null);

        // Transform skills string into an array: WHat the backend expects
        // This splits the string by commas, removes extra spaces, and removes empty entries
        const transformedSkills = typeof userDetails.skills === 'string'
            ? userDetails.skills.split(',').map(s => s.trim()).filter(s => s !== '')
            : (Array.isArray(userDetails.skills) ? userDetails.skills : []);

        // 1. Transform complex arrays to match API structure 
        const transformedWorkExperiences = (userDetails.work_experiences || []).map(exp => ({
            job_title: exp.job_title,
            company: exp.company,
            location: exp.location,
            dates: exp.dates,
            responsibilities: exp.responsibilities ? exp.responsibilities.split('\n').filter(line => line.trim() !== '') : [],
        }));

        const transformedEducations = (userDetails.educations || []).map(edu => ({
            degree: edu.degree,
            institution: edu.institution,
            location: edu.location,
            dates: edu.dates,
            achievements: edu.achievements || '',
        }));

        const transformedProjects = (userDetails.projects || []).map(p => ({
            name: p.name,
            url: p.url,
            dates: p.dates,
            summary: p.summary,
        }));

        const transformedCertifications = (userDetails.certifications || []).map(c => ({
            name: c.name,
            certificate_id: c.certificate_id,
            url: c.url,
            dates: c.dates,
            issuing_organization: c.issuing_organization,
        }));



        // 2. Construct the final API payload
        const finalPayload = {
            title: userDetails.title,
            template_id: selectedTemplate,
            full_name: userDetails.full_name,
            email: userDetails.email,
            phone: userDetails.phone,
            country: userDetails.country,
            city: userDetails.city,
            home_address: userDetails.home_address,
            postal_code: userDetails.postal_code,
            linkedin_url: userDetails.linkedin_url,
            portfolio_url: userDetails.portfolio_url,
            professional_summary: userDetails.professional_summary,
            work_experiences: transformedWorkExperiences,
            skills: transformedSkills,
            educations: transformedEducations,
            projects: transformedProjects,
            certifications: transformedCertifications,
        };

        console.log("--- API PAYLOAD SENT ---", finalPayload);
        console.log(`--- TARGET URL --- ${CV_CREATE_ENDPOINT}`);
        console.log(`--- AUTHORIZATION TOKEN --- Bearer ${userDetails.apiToken.substring(0, 10)}...`);

        try {
            // --- LIVE API CALL TO CREATE CV ENDPOINT ---
            const response = await fetch(CV_CREATE_ENDPOINT, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    // Use the token provided by the user
                    'Authorization': `Bearer ${API_TOKEN}`,
                },
                body: JSON.stringify(finalPayload),
            });

            const responseData = await response.json();



            if (!response.ok) {
                // Handle API errors (4xx, 5xx)
                console.error("API Error Response:", responseData);
                throw new Error(`API Error: ${response.status} - ${responseData.message || 'Failed to create CV. Check console for details.'}`);
            }

            const createdCvId = responseData.data.id || 'UNKNOWN_ID';
            console.log("CV Created Successfully. ID:", createdCvId);

            // Store the ID for the download step
            setUserDetails(prev => ({ ...prev, createdCvId: createdCvId }));

            setStatusMessage('success');
            // navigate(3); // Go to Download Page (Step 3)
            navigate(4); // Navigate to User Dashboard Now after downloading a CV.
            // navigate() to the popup asking them to pay instead and not bring user back to the dashboard page
        } catch (error) {
            console.error("CV Creation error:", error.message);
            setStatusMessage('error');
            setIsLoading(false);
        }
    };

    const handleCreateCVNoDownload = async () => {
        setIsLoading2(true);
        setStatusMessage(null);

        // 1. Transform complex arrays to match API structure 
        const transformedSkills = typeof userDetails.skills === 'string'
            ? userDetails.skills.split(',').map(s => s.trim()).filter(s => s !== '')
            : (Array.isArray(userDetails.skills) ? userDetails.skills : []);

        const transformedWorkExperiences = (userDetails.work_experiences || []).map(exp => ({
            job_title: exp.job_title,
            company: exp.company,
            location: exp.location,
            dates: exp.dates,
            responsibilities: exp.responsibilities ? exp.responsibilities.split('\n').filter(line => line.trim() !== '') : [],
        }));

        const transformedEducations = (userDetails.educations || []).map(edu => ({
            degree: edu.degree,
            institution: edu.institution,
            location: edu.location,
            dates: edu.dates,
            achievements: edu.achievements || '',
        }));

        const transformedProjects = (userDetails.projects || []).map(p => ({
            name: p.name,
            url: p.url,
            dates: p.dates,
            summary: p.summary,
        }));

        const transformedCertifications = (userDetails.certifications || []).map(c => ({
            name: c.name,
            certificate_id: c.certificate_id,
            url: c.url,
            dates: c.dates,
            issuing_organization: c.issuing_organization,
        }));


        // 2. Construct the final API payload
        const finalPayload = {
            title: userDetails.title,
            template_id: selectedTemplate,
            full_name: userDetails.full_name,
            email: userDetails.email,
            phone: userDetails.phone,
            country: userDetails.country,
            city: userDetails.city,
            home_address: userDetails.home_address,
            postal_code: userDetails.postal_code,
            linkedin_url: userDetails.linkedin_url,
            portfolio_url: userDetails.portfolio_url,
            professional_summary: userDetails.professional_summary,
            work_experiences: transformedWorkExperiences,
            skills: transformedSkills,
            educations: transformedEducations,
            projects: transformedProjects,
            certifications: transformedCertifications,
        };

        console.log("--- API PAYLOAD SENT ---", finalPayload);
        console.log(`--- TARGET URL --- ${CV_CREATE_ENDPOINT}`);
        console.log(`--- AUTHORIZATION TOKEN --- Bearer ${userDetails.apiToken.substring(0, 10)}...`);

        try {
            // --- LIVE API CALL TO SAVE CV ENDPOINT ---
            const response = await fetch(CV_CREATE_ENDPOINT, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${API_TOKEN}`,
                },
                body: JSON.stringify(finalPayload),
            });

            const responseData = await response.json();
            console.log(responseData.data)
            // console.log(responseData.data.id)

            if (!response.ok) {
                // Handle API errors (4xx, 5xx)
                console.error("API Error Response:", responseData);
                throw new Error(`API Error: ${response.status} - ${responseData.message || 'Failed to create CV. Check console for details.'}`);
            }

            const createdCvId = responseData.data.id || 'UNKNOWN_ID';
            console.log("CV Created Successfully. ID:", createdCvId);

            // Store the ID for the download step
            setUserDetails(prev => ({ ...prev, createdCvId: createdCvId }));

            setStatusMessage('success');
            alert("CV has been saved.");
            setIsLoading2(false);

            // User chooses to only Save CV.
            // navigate(3); // Go to Download Page (Step 3)

        } catch (error) {
            console.error("CV Creation error:", error.message);
            setStatusMessage('error');
            setIsLoading2(false);
        }
    };

    return (
        <div className="bg-gray-50 min-h-screen flex flex-col items-center p-4 sm:p-8">
            <div className="w-full max-w-5xl">
                <div className="flex justify-between items-center mb-6">
                    <h1 className="text-3xl font-extrabold text-gray-900">Step 2: Template Selection & Creation</h1>
                    <span className="text-sm font-semibold text-white bg-[#198754] px-4 py-1 rounded-full shadow-md">2/3</span>
                </div>
            </div>

            <button onClick={() => navigate(4)} className="text-sm text-[#198754] hover:underline flex items-center mt-2">
                Go to User Dashboard and See a list of CVs you have created in the past instead.
            </button>
            <br />

            {/* Warning Banner */}
            <div className="w-full max-w-5xl p-4 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 mb-6 rounded-lg shadow-md" role="alert">
                <p className="font-bold">IMPORTANT: </p>
                <p className="font-bold">kindly click on the CV Template of your choice and click the button below to create your CV </p>
                <p className="text-sm">
                    1. Clicking <b>**"Create CV"**</b> will create a CV that can then be generated later on.
                    <br /> 2. Clicking on <b>**"Save CV"**</b>  will only save the User's CV to our System.
                    <br /> <b>Note: To Download CV is not free but to save CV is completely free </b>
                </p>
            </div>


            <div className="w-full max-w-5xl grid grid-cols-1 lg:grid-cols-3 gap-8 mb-10">

                {/* Template Selection Section */}
                <div className="w-full space-y-4">
                    <h2 className="text-xl font-bold text-gray-800">Select Template</h2>
                    <div className="space-y-3">
                        {loadingTemplates ? (
                            <p>Loading templates...</p>
                        ) : (
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 justify-items-center">
                                {templates.map(template => {
                                    const isSelected = template.id === selectedTemplate;
                                    return (
                                        <div
                                            key={template.id}
                                            onClick={() => setSelectedTemplate(template.id)}
                                            className={`cursor-pointer group transform hover:scale-105 transition-transform`}
                                        >
                                            <div
                                                className={`aspect-[3/4] bg-white border-4 rounded-lg overflow-hidden shadow-lg
                            ${isSelected ? 'border-teal-500' : 'border-white'}
                            group-hover:border-teal-400`}
                                            >
                                                <img
                                                    src={getThumbnailUrl(template.url)}
                                                    alt={template.name}
                                                    className="w-full h-full object-cover"
                                                />
                                            </div>

                                            <p className="text-center mt-4 font-bold text-gray-700">
                                                {template.name}
                                            </p>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                    <button onClick={() => navigate(1)} className="text-sm text-[#198754] hover:underline flex items-center mt-2">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M11 17l-5-5m0 0l5-5m-5 5h12" /></svg>
                        Go Back to Edit Details (Step 1)
                    </button>
                </div>

                {/* CV Preview Section */}
                {/* <div className="lg:col-span-2 space-y-4">
                    <h2 className="text-xl font-bold text-gray-800">Live Preview: {templates.find(t => t.id === selectedTemplate)?.name}</h2>
                    <div className="p-1 border border-gray-300 rounded-lg bg-white shadow-xl max-h-[80vh] overflow-y-auto">
                        {renderTemplatePreview()}
                    </div>
                </div> */}
            </div>

            {/* Final Submission Button */}

            <div className="w-full max-w-5xl mx-auto flex flex-col sm:flex-row gap-4 justify-center items-center">
                {/* Create & Download */}
                <button
                    onClick={handleCreateCV}
                    disabled={isLoading}
                    className={`w-full sm:w-auto flex items-center justify-center gap-2 
                    px-6 py-3 sm:px-10 sm:py-4 rounded-full font-semibold text-white 
                    shadow-lg transition-all duration-200
                    ${isLoading
                            ? 'bg-gray-400 cursor-not-allowed'
                            : `${primaryColor} hover:opacity-90 active:scale-[0.98] hover:scale-[1.02]`
                        }`}
                >
                    {isLoading ? (
                        <>
                            <svg className="animate-spin h-4 w-4 text-white" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                <path className="opacity-75" fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                            </svg>
                            <span className="truncate">Creating CV...</span>
                        </>
                    ) : (
                        <span className="text-center">
                            Create CV & Proceed to Download
                        </span>
                    )}
                </button>

                {/* Save Only */}
                <button
                    onClick={handleCreateCVNoDownload}
                    disabled={isLoading2}
                    className={`w-full sm:w-auto flex items-center justify-center gap-2 
                    px-6 py-3 sm:px-10 sm:py-4 rounded-full font-semibold text-white 
                    shadow-lg transition-all duration-200
                    ${isLoading2
                            ? 'bg-gray-400 cursor-not-allowed'
                            : `${primaryColor} hover:opacity-90 active:scale-[0.98] hover:scale-[1.02]`
                        }`}
                >
                    {isLoading2 ? (
                        <>
                            <svg className="animate-spin h-4 w-4 text-white" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                <path className="opacity-75" fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                            </svg>
                            <span>Saving CV...</span>
                        </>
                    ) : (
                        "Save CV"
                    )}
                </button>

            </div>

            {statusMessage === 'error' && (
                <div className="mt-4 p-3 text-sm text-red-800 rounded-lg bg-red-50 w-full max-w-5xl" role="alert">
                    <p className='font-bold'>Creation Failed!</p>
                    <p>An error occurred during the API call. Please check your **API Token**, verify the **API URL** in the code, and examine the browser console for specific error details.</p>
                </div>
            )}
        </div>
    );
};


// --- 5. STEP 3: CV DOWNLOAD PAGE ---

const CVDownloadPage = ({ navigate }) => {
    const { userDetails, API_TOKEN, setUserDetails, setFormStatus } = useCVContext();

    // In a real application, you would use userDetails.createdCvId to fetch the PDF/File link
    // For now, we simulate the link using the created ID.
    console.log(userDetails);

    // const mockDownloadUrl = `${API_BASE_URL}/cvs/${userDetails.createdCvId}/download`;
    // const mockDownloadUrl = `${userDetails.cv.cv_url}`; // should store the actual url for the cv
    // Defensive check: handle cases where userDetails or cv might be missing initially
    const cvDownloadUrl = userDetails?.cv?.cv_url || "#";
    console.log(cvDownloadUrl);

    // Running another GET request on this: https://cv.signup.com.ng/v1/api/cvs/1/purchase
    // const GET_CV_URL = `https://cv.signup.com.ng/v1/api/cvs/1/purchase`

    // const fetchCvDetailsForCvUrl = async () => {
    //     try {
    //         const response = await fetch(`https://cv.signup.com.ng/v1/api/cvs/${userDetails.createdCvId}/purchase`, {
    //             method: 'GET',
    //             headers: {
    //                 'Authorization': `Bearer ${API_TOKEN}`,
    //                 'Content-Type': 'application/json',
    //             }
    //         });

    //         if (!response.ok) {
    //             throw new Error(`Failed to fetch CV details. Status: ${response.status}`)
    //         }

    //         if (!response.ok) {
    //             // if token is invalid, log user out and move them to login page
    //             if (response.status === 401) {

    //                 navigate('login'); // Redirect to login
    //             }
    //             throw new Error(`Failed to fetch CV details. Status: ${response.status}`);
    //         }

    //         const data = await response.json();

    //         // The API response structure might wrap the CV data
    //         const cvData = data.data || data;


    //     } catch (err) {
    //         console.error("Error fetching CV for edit:", err);
    //         setFormStatus('error_fetch');
    //     }
    //     fetchCvDetailsForCvUrl();
    // };
    const fetchCvDetailsForCvUrl = async () => {
        // Prevent call if no ID exists
        if (!userDetails?.createdCvId) return;

        try {
            const response = await fetch(`https://cv.signup.com.ng/v1/api/cvs/${userDetails.createdCvId}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${API_TOKEN}`,
                    'Content-Type': 'application/json',
                }
            });

            if (!response.ok) {
                if (response.status === 401) {
                    navigate('login');
                    return;
                }
                throw new Error(`Failed to fetch CV details. Status: ${response.status}`);
            }

            const data = await response.json();
            const cvData = data.data || data;

            console.log("After confirming the below returns the needed data, we will now update the UI so that we check if the response.cv.generate = true, we stop the loading and show users the button they can use in downloading the CV")
            console.log(response)
            console.log(data)
            console.log(cvData) // you can even copy and navigate them in the chrome's console. if CV has been generated, enable button that allows users to download CV.


            // 2. Actually update the context with the new data
            setUserDetails((prev) => ({ ...prev, ...cvData }));
            setFormStatus('success_fetch');

        } catch (err) {
            console.error("Error fetching CV:", err);
            setFormStatus('error_fetch');
        }
    };

    // 3. Trigger the fetch once when the component mounts
    useEffect(() => {
        fetchCvDetailsForCvUrl();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    // return (
    //     <div className="bg-gray-50 min-h-screen flex flex-col items-center justify-center p-4">
    //         <div className="bg-white p-10 rounded-xl shadow-2xl w-full max-w-xl text-center">
    //             <div className="flex justify-center items-center mb-6">
    //                 <h1 className="text-3xl font-extrabold text-gray-900 mr-4">Step 3: Download CV</h1>
    //                 <span className="text-sm font-semibold text-white bg-[#198754] px-4 py-1 rounded-full shadow-md">3/3</span>
    //             </div>

    //             <svg xmlns="http://www.w3.org/2000/svg" className="h-20 w-20 text-[#198754] mx-auto mb-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    //                 <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
    //             </svg>

    //             <h2 className="text-2xl font-bold text-gray-800 mb-2">CV Created Successfully!</h2>
    //             <p className="text-gray-600 mb-4">
    //                 Your CV, <b>{userDetails.title}</b>, with (ID: <b>{userDetails.createdCvId}</b>)is currently generating, check back in a minute to download your CV.
    //             </p>
    //             {/* Later on: It will NO longer show CV url immediately CV is generated  */}
    //             <p className="text-sm text-gray-500 mb-8">
    //                 You can now use your backend's `GET /cvs/{userDetails.id}` or a download endpoint with the ID **{userDetails.createdCvId}** to retrieve the file.
    //             </p>

    //             <a
    //                 href={mockDownloadUrl}
    //                 // For demonstration, we'll keep the download link as a simple text file
    //                 download={`${userDetails.full_name.replace(/\s/g, '_')}_CV_ID_${userDetails.createdCvId}.txt`}
    //                 className={`w-full sm:w-auto px-8 py-3 rounded-full font-bold text-white shadow-xl ${primaryColor} mb-4 block sm:inline-block`}
    //                 target="_blank"
    //                 rel="noopener noreferrer"
    //             >
    //                 Download CV File (Mock Link)
    //             </a>
    //             {/* if all goes well, after usr generates CV, they should be able to see the link from cloudinary to download their CV */}

    //             <button
    //                 onClick={() => navigate(4)}
    //                 className="w-full text-lg font-semibold px-6 py-3 rounded-xl shadow-lg transition duration-300 border-2 border-green-700 bg-white text-green-700 hover:bg-green-50"
    //             >
    //                 Go to User Dashboard &rarr;
    //             </button>

    //             <button
    //                 onClick={() => navigate(1)}
    //                 className={`w-full sm:w-auto mt-4 ${secondaryButton}`}
    //             >
    //                 Start New CV (Go to Step 1)
    //             </button>
    //         </div>
    //     </div>
    // );

    return (
        <div className="bg-gray-50 min-h-screen flex flex-col items-center justify-center p-4">
            <div className="bg-white p-10 rounded-xl shadow-2xl w-full max-w-xl text-center">
                <div className="flex justify-center items-center mb-6">
                    <h1 className="text-3xl font-extrabold text-gray-900 mr-4">Step 3: Download CV</h1>
                    <span className="text-sm font-semibold text-white bg-[#198754] px-4 py-1 rounded-full shadow-md">3/3</span>
                </div>

                <svg xmlns="http://www.w3.org/2000/svg" className="h-20 w-20 text-[#198754] mx-auto mb-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>

                <h2 className="text-2xl font-bold text-gray-800 mb-2">CV Created Successfully!</h2>
                <p className="text-gray-600 mb-4">
                    Your CV, <b>{userDetails?.title || 'Your CV'}</b>, with (ID: <b>{userDetails?.createdCvId}</b>) is currently generating. Wait for a Minute and then click the button to download your CV
                </p>

                <a
                    href={cvDownloadUrl}
                    // download={`${userDetails?.full_name?.replace(/\s/g, '_') || 'My'}_CV.pdf`}
                    className={`w-full sm:w-auto px-8 py-3 rounded-full font-bold text-white shadow-xl ${primaryColor} mb-4 block sm:inline-block`}
                    target="_blank"
                // rel="noopener noreferrer"
                >
                    Download CV File
                </a>

                <button
                    onClick={() => navigate(4)}
                    className="w-full text-lg font-semibold px-6 py-3 rounded-xl shadow-lg transition duration-300 border-2 border-green-700 bg-white text-green-700 hover:bg-green-50"
                >
                    Go to User Dashboard &rarr;
                </button>

                <button
                    onClick={() => navigate(1)}
                    className={`w-full sm:w-auto mt-4 ${secondaryButton}`}
                >
                    Start New CV (Go to Step 1)
                </button>
            </div>
        </div>
    );
};

const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState(() => {
        // Initialize state from localStorage
        const token = localStorage.getItem('auth_token');
        const userData = localStorage.getItem('user_data');

        return {
            isAuthenticated: !!token,
            token: token,
            user: userData ? JSON.parse(userData) : null
        };
    });

    useEffect(() => {
        console.log("AUTH STATE UPDATED:", auth);
    }, [auth]);

    const logout = () => {
        localStorage.removeItem('auth_token');
        localStorage.removeItem('user_data');
        localStorage.removeItem('referral_code');
        // localStorage.removeItem('user_email');
        setAuth({
            isAuthenticated: false,
            token: null,
            user: null
        });
    };

    const value = { auth, setAuth, logout };

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};




// --- AuthComponent.js (Conceptual - put these functions/components into App.js for the one-file requirement) ---
// const AUTH_API_URL = 'https://test.signup.com.ng/v1/api/auth';
const AUTH_API_URL = 'https://cv.signup.com.ng/v1/api/auth';
// const inputClasses = "w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#198754] focus:border-transparent transition duration-150";

// A utility function to save the token and user details upon successful auth
const saveAuthDetails = (token, userDetails, setAuth) => {
    localStorage.setItem('auth_token', token);
    localStorage.setItem('user_data', JSON.stringify(userDetails));
    localStorage.setItem('referral_code', userDetails.referral_code);
    localStorage.setItem('user_email', userDetails.email);
    console.log("storing needed values in local storage(auth_token, user_data, referral_code)");

    setAuth({
        isAuthenticated: true,
        token: token,
        user: userDetails
    });
};

const actualUserBalance = 0;

// // --- LoginForm Component ---
// const LoginForm = ({ setAuth, navigate }) => {
//     const [email, setemail] = React.useState('');
//     const [password, setPassword] = React.useState('');
//     const [status, setStatus] = React.useState(null); // 'loading', 'error'

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setStatus('loading');

//         try {
//             const response = await fetch(`${AUTH_API_URL}/login`, {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({ email, password }),
//             });

//             const data = await response.json();

//             if (!response.ok) {
//                 // Assuming API returns an error message in the data object
//                 throw new Error(data.message || 'Login failed.');
//             }

//             // Assuming the API returns a token and user details upon success
//             const token = data.token; // Get the Bearer token
//             const userDetails = data.user; // Get user details

//             saveAuthDetails(token, userDetails, setAuth);
//             console.log(userDetails);
//             // actualUserBalance = userDetails.balance;
//             setStatus('success');
//             navigate(1); // Navigate to CVFormPage (Step 1)

//         } catch (error) {
//             console.error('Login Error:', error);
//             setStatus('error');
//         }
//     };


//     return (
//         <form onSubmit={handleSubmit} className="p-6 sm:p-10 bg-white rounded-xl shadow-2xl max-w-sm mx-auto my-10 space-y-4">
//             <h2 className="text-3xl font-extrabold text-gray-900 text-center mb-6">🔑 Login Now</h2>
//             {/* {status === 'error' && (
//                 <div className="p-3 text-sm text-red-800 rounded-lg bg-red-50">Login failed. Please check your credentials.</div>
//             )} */}

//             {/* <input type="email" value={email} onChange={(e) => setemail(e.target.value)} placeholder="Email" className={inputClasses} required />
//             <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className={inputClasses} required /> */}

//             <button type="submit" className="w-full py-3 rounded-lg font-bold text-white bg-[#198754] hover:bg-[#156e43] transition duration-150 shadow-md" onClick={() => {
//                 window.location.href = "https://signup.com.ng/sso/authorize?service=cv-app"
//             }}>
//                 Login Now

//             </button>




//             {/* Getting the ticket from the URl */}

//             {/* what was gotten: https://cv.signup.com.ng/auth/callback?ticket=0ZgjLqIzrHAAlpy8nDIoV8r60XAgfsoxTLZbMmoP
//             is there a ticket, YES| */}

//             {/* A function to get the ticket and send to Dev. Jonathan */}




//             {/* <p className="text-center text-sm text-gray-600">
//                 Don't have an account?{' '}
//                 <button type="button" onClick={() => navigate('signup')} className="text-[#198754] hover:underline font-medium">Sign Up</button>
//             </p> */}
//         </form>
//     );
// };



/* ---------------- TEMPLATE PREVIEWS ---------------- */

const ATSTemplatePreview = () => (
    <div className="h-full w-full overflow-hidden bg-white font-mono text-xs sm:text-sm text-gray-800 leading-snug p-3 sm:p-4 md:p-5 space-y-3">

        {/* Header */}
        <header className="text-center space-y-1">
            <h1 className="font-bold uppercase text-sm sm:text-base truncate">
                {initialUserDetails.full_name}
            </h1>

            <p className="text-[10px] sm:text-xs uppercase border-b border-gray-400 pb-1 break-words">
                {initialUserDetails.phone} | {initialUserDetails.email} | {initialUserDetails.city}
            </p>
        </header>


        {/* Summary */}
        <section className="space-y-1">
            <h2 className="font-bold uppercase border-b border-gray-800 pb-1 text-xs sm:text-sm">
                Summary
            </h2>

            <p className="line-clamp-3 text-[11px] sm:text-xs">
                {initialUserDetails.professional_summary}
            </p>
        </section>


        {/* Experience */}
        <section className="space-y-1">
            <h2 className="font-bold uppercase border-b border-gray-800 pb-1 text-xs sm:text-sm">
                Experience
            </h2>

            {initialUserDetails.work_experiences.slice(0, 2).map(exp => (
                <div key={exp.id} className="space-y-1">

                    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center font-bold text-[11px] sm:text-xs gap-1">

                        <span className="truncate">
                            {exp.job_title} – {exp.company}
                        </span>

                        <span className="text-[10px] sm:text-xs shrink-0">
                            {exp.dates}
                        </span>

                    </div>

                    <p className="text-[10px] sm:text-xs truncate">
                        {exp.location}
                    </p>

                </div>
            ))}
        </section>


        {/* Projects */}
        <section className="space-y-1">
            <h2 className="font-bold uppercase border-b border-gray-800 pb-1 text-xs sm:text-sm">
                Projects
            </h2>

            {initialUserDetails.projects.slice(0, 1).map(proj => (
                <div key={proj.id} className="space-y-1">

                    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center font-bold text-[11px] sm:text-xs gap-1">

                        <span className="truncate">
                            {proj.name}
                        </span>

                        <span className="text-[10px] sm:text-xs shrink-0">
                            {proj.dates}
                        </span>

                    </div>

                    <p className="line-clamp-2 text-[10px] sm:text-xs">
                        {proj.summary}
                    </p>

                </div>
            ))}
        </section>


        {/* Education */}
        <section className="space-y-1">
            <h2 className="font-bold uppercase border-b border-gray-800 pb-1 text-xs sm:text-sm">
                Education
            </h2>

            {initialUserDetails.educations.slice(0, 1).map(edu => (
                <div key={edu.id} className="space-y-1">

                    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center font-bold text-[11px] sm:text-xs gap-1">

                        <span className="truncate">
                            {edu.degree}, {edu.institution}
                        </span>

                        <span className="text-[10px] sm:text-xs shrink-0">
                            {edu.dates}
                        </span>

                    </div>

                    <p className="text-[10px] sm:text-xs truncate">
                        {edu.location}
                    </p>

                </div>
            ))}
        </section>


        {/* Certifications */}
        <section className="space-y-1">
            <h2 className="font-bold uppercase border-b border-gray-800 pb-1 text-xs sm:text-sm">
                Certifications
            </h2>

            {initialUserDetails.certifications.slice(0, 1).map(cert => (
                <p key={cert.id} className="text-[11px] sm:text-xs truncate">
                    <span className="font-bold">{cert.name}</span> — {cert.issuing_organization}
                </p>
            ))}
        </section>

    </div>
);

const ModernTemplatePreview = () => (
    <div className="grid grid-cols-1 md:grid-cols-4 h-full w-full overflow-hidden bg-white text-xs sm:text-sm text-gray-800 leading-snug">

        {/* Sidebar */}
        <div className="md:col-span-1 bg-gray-900 text-white p-3 sm:p-4 space-y-4">

            {/* Name */}
            <div className="text-center">
                <h1 className="text-base sm:text-lg font-extrabold leading-tight break-words">
                    {initialUserDetails.full_name.split(' ')[0]}
                </h1>

                <h1 className="text-base sm:text-lg font-extrabold -mt-1 leading-tight break-words">
                    {initialUserDetails.full_name.split(' ').slice(1).join(' ')}
                </h1>

                <p className="text-xs font-light text-[#198754] uppercase tracking-wide mt-1">
                    {initialUserDetails.title}
                </p>
            </div>

            {/* Contact */}
            <div className="space-y-2">
                <h3 className="text-xs font-bold uppercase tracking-widest border-b border-gray-700 pb-1 text-[#198754]">
                    Contact
                </h3>

                <div className="text-xs space-y-1 break-words">
                    <p>{initialUserDetails.phone}</p>
                    <p className="break-all">{initialUserDetails.email}</p>
                    <p>{initialUserDetails.city}, {initialUserDetails.country}</p>
                </div>
            </div>

            {/* Links */}
            <div className="space-y-2">
                <h3 className="text-xs font-bold uppercase tracking-widest border-b border-gray-700 pb-1 text-[#198754]">
                    Links
                </h3>

                <div className="text-xs space-y-1 break-all">
                    {initialUserDetails.linkedin_url && (
                        <p>{initialUserDetails.linkedin_url}</p>
                    )}

                    {initialUserDetails.portfolio_url && (
                        <p>{initialUserDetails.portfolio_url}</p>
                    )}
                </div>
            </div>

            {/* Certifications */}
            <div className="space-y-2">
                <h3 className="text-xs font-bold uppercase tracking-widest border-b border-gray-700 pb-1 text-[#198754]">
                    Certs
                </h3>

                <div className="space-y-1">
                    {initialUserDetails.certifications.slice(0, 2).map(cert => (
                        <div key={cert.id}>
                            <p className="font-semibold text-xs leading-tight break-words">
                                {cert.name}
                            </p>

                            <p className="text-gray-400 italic text-[11px] break-words">
                                {cert.issuing_organization}
                            </p>
                        </div>
                    ))}
                </div>
            </div>

        </div>

        {/* Main Content */}
        <div className="md:col-span-3 p-3 sm:p-4 space-y-4 overflow-hidden">

            {/* Profile */}
            <div className="pb-2 border-b border-gray-300">
                <h3 className="text-sm font-extrabold uppercase text-gray-700">
                    Profile
                </h3>

                <p className="text-xs sm:text-sm line-clamp-4">
                    {initialUserDetails.professional_summary}
                </p>
            </div>

            {/* Experience */}
            <div className="pb-2 border-b border-gray-300">
                <h3 className="text-sm font-extrabold uppercase text-gray-700 mb-2">
                    Experience
                </h3>

                {initialUserDetails.work_experiences.slice(0, 2).map(exp => (
                    <div key={exp.id} className="mb-3">

                        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-baseline gap-1">
                            <h4 className="font-bold text-sm text-[#198754] break-words">
                                {exp.job_title}
                            </h4>

                            <span className="text-xs text-gray-600">
                                {exp.dates}
                            </span>
                        </div>

                        <p className="text-xs italic break-words">
                            {exp.company}
                        </p>

                    </div>
                ))}
            </div>

            {/* Education */}
            <div>
                <h3 className="text-sm font-extrabold uppercase text-gray-700 mb-2">
                    Education
                </h3>

                {initialUserDetails.educations.slice(0, 1).map(edu => (
                    <div key={edu.id}>
                        <p className="font-bold text-sm break-words">
                            {edu.degree}
                        </p>

                        <p className="text-xs italic break-words">
                            {edu.institution}
                        </p>
                    </div>
                ))}
            </div>

        </div>

    </div>
);


const CreativeColorfulTemplatePreview = () => (
    <div className="flex flex-col md:flex-row h-full w-full overflow-hidden bg-white font-sans text-xs sm:text-sm text-gray-800 leading-snug">

        {/* Sidebar */}
        <aside className="md:w-1/3 w-full bg-gradient-to-b from-pink-500 via-purple-600 to-indigo-700 text-white p-4 md:p-3 space-y-4">

            {/* Name */}
            <div>
                <h1 className="text-base sm:text-lg md:text-sm font-black uppercase leading-tight tracking-tight break-words">
                    {userDetails.full_name}
                </h1>
                <p className="text-xs md:text-[10px] text-pink-200 font-medium tracking-widest uppercase mt-1 break-words">
                    {userDetails.job_title}
                </p>
            </div>

            {/* Details */}
            <section className="space-y-2">
                <h2 className="text-xs md:text-[11px] font-bold border-b border-pink-300 pb-1 uppercase">
                    Details
                </h2>

                <div className="space-y-1 text-xs md:text-[10px]">
                    <p className="break-all">{userDetails.email}</p>
                    <p>{userDetails.phone}</p>
                </div>
            </section>

            {/* Skills */}
            <section className="space-y-2">
                <h2 className="text-xs md:text-[11px] font-bold border-b border-pink-300 pb-1 uppercase">
                    Skills
                </h2>

                <div className="flex flex-wrap gap-2">
                    {userDetails.skills.slice(0, 6).map((skill, index) => (
                        <span
                            key={index}
                            className="bg-white/20 px-2 py-1 rounded text-xs md:text-[10px] border border-white/30"
                        >
                            {skill}
                        </span>
                    ))}
                </div>
            </section>
        </aside>

        {/* Main Content */}
        <main className="md:w-2/3 w-full p-4 md:p-3 space-y-4 overflow-hidden">

            {/* Experience */}
            <section className="space-y-3">
                <h2 className="text-sm md:text-xs font-black uppercase italic bg-clip-text text-transparent bg-gradient-to-r from-purple-600 to-pink-500">
                    Experience
                </h2>

                {userDetails.work_experiences.slice(0, 2).map((exp, index) => (
                    <div key={index} className="relative pl-4 border-l border-purple-200">
                        <span className="absolute w-2 h-2 bg-pink-500 rounded-full -left-1 top-1" />

                        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-baseline">
                            <h3 className="font-bold text-xs md:text-[10px] text-gray-900 break-words">
                                {exp.job_title}
                            </h3>
                            <span className="text-xs md:text-[9px] font-bold text-purple-600 shrink-0">
                                {exp.dates}
                            </span>
                        </div>

                        <p className="text-xs md:text-[9px] font-semibold text-indigo-600 break-words">
                            {exp.company}
                        </p>
                    </div>
                ))}
            </section>

            {/* Education */}
            <section className="space-y-3">
                <h2 className="text-sm md:text-xs font-black uppercase italic bg-clip-text text-transparent bg-gradient-to-r from-indigo-600 to-purple-500">
                    Education
                </h2>

                {userDetails.educations.slice(0, 1).map((edu, index) => (
                    <div key={index} className="bg-gray-50 p-3 md:p-2 rounded border-l-4 border-indigo-500">
                        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-baseline">
                            <h3 className="font-bold text-xs md:text-[10px] break-words">
                                {edu.degree}
                            </h3>
                            <span className="text-xs md:text-[9px] uppercase text-gray-400 shrink-0">
                                {edu.dates}
                            </span>
                        </div>
                        <p className="text-xs md:text-[9px] text-indigo-600 break-words">
                            {edu.institution}
                        </p>
                    </div>
                ))}
            </section>
        </main>
    </div>
);


const BoldDynamicTemplatePreview = () => (
    <div className="h-full w-full overflow-hidden bg-white font-sans text-xs md:text-[10px] text-gray-800 leading-snug border border-gray-200">

        {/* Header */}
        <header className="bg-slate-900 text-white p-4 md:p-3 space-y-2">
            <h1 className="text-base md:text-sm font-black uppercase tracking-tight break-words">
                {userDetails.full_name}
            </h1>

            <p className="text-xs md:text-[10px] text-blue-400 font-bold uppercase tracking-widest break-words">
                {userDetails.job_title}
            </p>

            <div className="flex flex-col sm:flex-row sm:flex-wrap gap-x-3 gap-y-1 text-xs md:text-[9px] opacity-90">
                <span className="break-words">{userDetails.address}</span>
                <span>{userDetails.phone}</span>
                <span className="break-all">{userDetails.email}</span>
            </div>
        </header>

        {/* Body */}
        <div className="p-4 md:p-3 grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-3 h-full">

            {/* Main Content */}
            <div className="col-span-1 md:col-span-8 space-y-4 md:space-y-3 overflow-hidden">

                {/* Experience */}
                <section className="space-y-2">
                    <div className="flex items-center">
                        <h2 className="text-sm md:text-xs font-black uppercase text-slate-900">
                            Experience
                        </h2>
                        <div className="flex-grow h-0.5 bg-slate-100 ml-2" />
                    </div>

                    {userDetails.work_experiences.slice(0, 2).map((exp, index) => (
                        <div key={index} className="space-y-1">
                            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-baseline">
                                <h3 className="font-bold text-xs md:text-[10px] text-slate-800 break-words">
                                    {exp.job_title}
                                </h3>

                                <span className="bg-blue-50 text-blue-700 px-2 py-0.5 rounded text-xs md:text-[9px] font-bold shrink-0">
                                    {exp.dates}
                                </span>
                            </div>

                            <p className="text-xs md:text-[9px] font-bold text-blue-600 break-words">
                                {exp.company}
                            </p>
                        </div>
                    ))}
                </section>

                {/* Education */}
                <section className="space-y-2">
                    <div className="flex items-center">
                        <h2 className="text-sm md:text-xs font-black uppercase text-slate-900">
                            Education
                        </h2>
                        <div className="flex-grow h-0.5 bg-slate-100 ml-2" />
                    </div>

                    {userDetails.educations.slice(0, 1).map((edu, index) => (
                        <div
                            key={index}
                            className="bg-slate-50 p-3 md:p-2 rounded border-l-4 md:border-l-2 border-slate-900"
                        >
                            <h3 className="font-bold text-xs md:text-[10px] break-words">
                                {edu.degree}
                            </h3>

                            <p className="text-blue-600 font-bold text-xs md:text-[9px] break-words">
                                {edu.institution}
                            </p>
                        </div>
                    ))}
                </section>
            </div>

            {/* Sidebar */}
            <div className="col-span-1 md:col-span-4">
                <section className="bg-slate-900 text-white p-3 md:p-2 rounded-xl h-full">
                    <h2 className="text-xs md:text-[10px] font-black uppercase tracking-tight mb-3 text-blue-400 text-center">
                        Skills
                    </h2>

                    <div className="flex flex-wrap gap-2 md:gap-1">
                        {userDetails.skills?.slice(0, 6).map((skill, index) => (
                            <span
                                key={index}
                                className="bg-slate-800 border border-slate-700 px-2 py-1 md:px-1.5 md:py-0.5 rounded text-xs md:text-[9px] font-bold uppercase tracking-wide w-full text-center break-words"
                            >
                                {skill}
                            </span>
                        ))}
                    </div>
                </section>
            </div>

        </div>
    </div>
);

const CreativeTemplatePreview = () => (
    <div className="max-w-4xl mx-auto bg-white shadow-2xl font-sans text-gray-900 border border-gray-200">

        {/* Header */}
        <header className="p-6 sm:p-8 md:p-10 border-b-8 border-black relative">

            <p className="text-[10px] sm:text-xs font-black tracking-[0.35em] sm:tracking-[0.45em] uppercase text-gray-400 mb-2 sm:mb-3 break-words">
                {initialUserDetails.job_title}
            </p>

            <h1 className="text-3xl sm:text-4xl md:text-6xl font-black uppercase tracking-tight leading-tight md:leading-none mb-4 sm:mb-6 break-words">
                {initialUserDetails.full_name}
            </h1>

            <div className="flex flex-col sm:flex-row sm:flex-wrap gap-x-4 gap-y-1 text-xs sm:text-[11px] font-bold uppercase tracking-widest text-gray-500">
                <span className="break-words">{initialUserDetails.address}</span>
                <span className="hidden sm:inline opacity-30">|</span>
                <span>{initialUserDetails.phone}</span>
                <span className="hidden sm:inline opacity-30">|</span>
                <span className="break-all">{initialUserDetails.email}</span>
            </div>

            {/* Decorative Accent */}
            <div className="absolute right-6 sm:right-8 md:right-10 top-6 sm:top-8 md:top-10 w-8 sm:w-10 h-1 bg-black" />
        </header>


        {/* Main Layout */}
        <div className="p-6 sm:p-8 md:p-10 grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12">

            {/* Left Column — Skills */}
            <aside className="md:col-span-4">

                <h2 className="text-lg sm:text-xl font-black uppercase tracking-widest mb-6 sm:mb-8 border-b-4 border-black pb-2">
                    Skills
                </h2>

                <div className="flex flex-col gap-4 sm:gap-5">

                    {initialUserDetails.skills.map((skill, index) => (
                        <div
                            key={index}
                            className="group flex items-center justify-between gap-3"
                        >
                            <span className="text-sm font-bold uppercase tracking-wider text-gray-800 break-words">
                                {skill}
                            </span>

                            <div className="flex items-center gap-2 shrink-0">
                                <div className="h-2 w-5 sm:w-6 bg-gray-300 group-hover:bg-black transition-all" />
                                <div className="h-2 w-8 sm:w-10 bg-black group-hover:w-14 sm:group-hover:w-16 transition-all duration-300" />
                            </div>
                        </div>
                    ))}

                </div>
            </aside>


            {/* Right Column */}
            <main className="md:col-span-8 space-y-10 sm:space-y-12 md:space-y-14">

                {/* Experience */}
                <section>

                    <h2 className="text-lg sm:text-xl font-black uppercase tracking-widest mb-6 sm:mb-10 border-b-4 border-black pb-2">
                        Experience
                    </h2>

                    <div className="space-y-8 sm:space-y-10 md:space-y-12">

                        {initialUserDetails.work_experiences.map((exp, index) => (
                            <div key={index}>

                                <p className="text-[9px] sm:text-[10px] font-black uppercase tracking-[0.25em] sm:tracking-[0.3em] text-gray-400 mb-2 sm:mb-3">
                                    {exp.dates}
                                </p>

                                <div className="mb-3 sm:mb-4">
                                    <h3 className="text-base sm:text-lg font-black uppercase tracking-tight break-words">
                                        {exp.job_title}
                                    </h3>

                                    <p className="text-sm font-bold text-gray-500 italic break-words">
                                        {exp.company}
                                    </p>
                                </div>

                                <div className="pl-3 sm:pl-4 border-l-2 border-gray-200">
                                    <ListRenderer text={exp.responsibilities} />
                                </div>

                            </div>
                        ))}

                    </div>

                </section>


                {/* Education */}
                <section>

                    <h2 className="text-lg sm:text-xl font-black uppercase tracking-widest mb-6 sm:mb-10 border-b-4 border-black pb-2">
                        Education
                    </h2>

                    <div className="space-y-6 sm:space-y-8 md:space-y-10">

                        {initialUserDetails.educations.map((edu, index) => (
                            <div key={index}>

                                <h3 className="text-sm sm:text-md font-black uppercase tracking-tight mb-1 break-words">
                                    {edu.degree}
                                </h3>

                                <p className="text-sm font-bold text-gray-500 mb-2 break-words">
                                    {edu.institution}
                                </p>

                                <p className="text-xs sm:text-sm text-gray-600 leading-relaxed font-medium break-words">
                                    {edu.achievements}
                                </p>

                            </div>
                        ))}

                    </div>

                </section>

            </main>
        </div>
    </div>
);

const SimpleTemplatePreview = () => (
    <div className="w-full h-full bg-white border border-gray-200 rounded-lg overflow-hidden">
        {/* Scale wrapper */}
        <div className="origin-top-left scale-[0.55] w-[180%] h-[180%] -translate-x-2 pointer-events-none">
            <div className="p-8 space-y-4 text-gray-800 text-sm">

                {/* Header */}
                <header className="text-center pb-4 border-b-4 border-gray-900">
                    <h1 className="text-3xl font-extrabold text-gray-900">
                        {initialUserDetails2.full_name}
                    </h1>

                    <p className="text-sm text-gray-600 space-x-3 mt-1">
                        <span>{initialUserDetails2.phone}</span> |
                        <span>{initialUserDetails2.email}</span> |
                        <span>
                            {initialUserDetails2.city}, {initialUserDetails2.country}
                        </span>
                    </p>

                    <p className="text-sm text-gray-600 space-x-3 mt-1">
                        {initialUserDetails2.linkedin_url && (
                            <span>{initialUserDetails2.linkedin_url}</span>
                        )}{" "}
                        |
                        {initialUserDetails2.portfolio_url && (
                            <span>{initialUserDetails2.portfolio_url}</span>
                        )}
                    </p>
                </header>

                {/* Summary */}
                <SectionTitle>Professional Summary</SectionTitle>
                <p>{initialUserDetails2.professional_summary}</p>

                {/* Experience */}
                <SectionTitle>Work Experience</SectionTitle>
                {initialUserDetails2.work_experiences.map(exp => (
                    <div key={exp.id} className="mb-4">
                        <div className="flex justify-between font-semibold">
                            <span>
                                {exp.job_title} at {exp.company}
                            </span>
                            <span className="text-xs text-gray-500">
                                {exp.dates} | {exp.location}
                            </span>
                        </div>
                        <ListRenderer text={exp.responsibilities} />
                    </div>
                ))}

                {/* Projects */}
                <SectionTitle>Key Projects</SectionTitle>
                {initialUserDetails2.projects.map(proj => (
                    <div key={proj.id} className="mb-4">
                        <div className="flex justify-between font-semibold">
                            <span>{proj.name}</span>
                            <span className="text-xs text-gray-500">{proj.dates}</span>
                        </div>
                        <p className="italic">{proj.summary}</p>
                    </div>
                ))}

                {/* Education */}
                <SectionTitle>Education</SectionTitle>
                {initialUserDetails2.educations.map(edu => (
                    <div key={edu.id} className="mb-4">
                        <div className="flex justify-between font-semibold">
                            <span>
                                {edu.degree}, {edu.institution}
                            </span>
                            <span className="text-xs text-gray-500">
                                {edu.dates} | {edu.location}
                            </span>
                        </div>
                    </div>
                ))}

                {/* Certifications */}
                <SectionTitle>Certifications</SectionTitle>
                <ul className="grid grid-cols-2 gap-x-4">
                    {initialUserDetails2.certifications.map(cert => (
                        <li key={cert.id} className="mb-2">
                            <span className="font-semibold">{cert.name}</span>
                            <p className="text-xs italic">
                                {cert.issuing_organization}
                            </p>
                        </li>
                    ))}
                </ul>

            </div>
        </div>
    </div>
);




const LoginForm = ({ navigate }) => {
    const [menuOpen, setMenuOpen] = useState(false);

    const isCallbackPage =
        window.location.href === "https://cv.signup.com.ng/auth/callback";

    // const buttonLabel = isCallbackPage ? "Go To Dashboard" : "Login Now";
    const token = localStorage.getItem("auth_token");
    const isAuthenticated = !!token;

    const buttonLabel = isAuthenticated
        ? "Dashboard"
        : "Login";
    const handleLoginRedirect = () => {
        if (isAuthenticated) {
            navigate("/dashboard");
        } else {
            window.location.href =
                "https://signup.com.ng/sso/authorize?service=cv-app";
        }
    };

    const handleRegisterRedirect = () => {
        window.location.href = "https://signup.com.ng/hub/register";
    }

    // GUEST FUNCTIONALITY
    const handleGuestRedirect = () => {
        navigate('guest')
    }



    const templates = [
        { id: "ats", name: "ATS Optimized", preview: <ATSTemplatePreview /> },
        { id: "modern", name: "Modern Elegant", preview: <ModernTemplatePreview /> },
        { id: "tech", name: "Futuristic Tech", preview: <CreativeColorfulTemplatePreview /> },
        {
            id: "executive",
            name: "Executive Refined",
            preview: <BoldDynamicTemplatePreview />,
        },
        { id: "creative", name: "Creative Bold", preview: <CreativeTemplatePreview /> },
        {
            id: "marketing",
            name: "Marketing Impact",
            preview: <SimpleTemplatePreview />,
        },
    ];

    return (
        <div className="min-h-screen bg-white text-slate-900">

            {/* NAV */}
            {/* <nav className="flex justify-between items-center max-w-7xl mx-auto px-6 py-6">
                <div className="flex items-center gap-2">
                    <div className="w-10 h-10 bg-[#198754] rounded-xl flex items-center justify-center">
                        <Zap className="text-white" />
                    </div>
                    <span className="text-xl font-black">
                        CV<span className="text-[#198754]">GEN</span>
                    </span>
                </div>

                <button
                    onClick={(handleGuestRedirect)}
                    className="flex items-center gap-1 px-2 py-4 bg-[#198754] text-white rounded-2xl font-black text-sm hover:bg-[#156e43]"
                >
                    Get Started As Guest<ArrowRight />
                </button>
                <button
                    onClick={(handleRegisterRedirect)}
                    className="flex items-center gap-1 px-2 py-4 bg-[#198754] text-white rounded-2xl font-black text-sm hover:bg-[#156e43]"
                >
                    Register<ArrowRight />
                </button>
                <button
                    onClick={handleLoginRedirect}
                    className="flex items-center gap-2 px-6 py-2.5 rounded-full border font-bold hover:bg-slate-50"
                >
                    <LogIn size={18} />
                    {buttonLabel}
                </button>
            </nav> */}

            <nav className="fixed top-0 left-0 w-full bg-white/80 backdrop-blur-md border-b shadow-sm z-50">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between">

                    {/* Logo */}
                    <div className="flex items-center gap-2 sm:gap-3 min-w-0">
                        <div className="w-8 h-8 sm:w-9 sm:h-9 bg-[#198754] rounded-lg flex items-center justify-center shrink-0">
                            <Zap className="text-white" size={18} />
                        </div>

                        <span className="text-base sm:text-lg font-extrabold truncate">
                            CV<span className="text-[#198754]">GEN</span>
                        </span>
                    </div>


                    {/* Desktop Actions */}
                    <div className="hidden md:flex items-center gap-3 lg:gap-4">

                        {!isAuthenticated && (
                            <>
                                <button
                                    onClick={handleGuestRedirect}
                                    className="flex items-center gap-2 px-4 py-2 bg-[#198754] text-white rounded-lg 
                                   font-semibold text-sm hover:bg-[#156e43] transition-all duration-200
                                   whitespace-nowrap"
                                >
                                    Get Started
                                    <ArrowRight size={16} />
                                </button>

                                <button
                                    onClick={handleRegisterRedirect}
                                    className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-semibold 
                                   hover:bg-gray-50 transition-all duration-200 whitespace-nowrap"
                                >
                                    Register
                                </button>
                            </>
                        )}

                        <button
                            onClick={handleLoginRedirect}
                            className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg 
                           text-sm font-semibold hover:bg-gray-50 transition-all duration-200
                           whitespace-nowrap"
                        >
                            <LogIn size={16} />
                            <span className="truncate max-w-[100px]">{buttonLabel}</span>
                        </button>
                    </div>


                    {/* Mobile Hamburger */}
                    <button
                        className="md:hidden flex items-center justify-center p-2 rounded-lg hover:bg-gray-100 transition"
                        onClick={() => setMenuOpen(!menuOpen)}
                    >
                        <Menu size={22} />
                    </button>
                </div>


                {/* Mobile Menu */}
                {menuOpen && (
                    <div className="md:hidden px-4 sm:px-6 pb-5 pt-3 space-y-3 bg-white border-t shadow-sm">

                        {!isAuthenticated && (
                            <>
                                <button
                                    onClick={handleGuestRedirect}
                                    className="w-full flex justify-center items-center gap-2 px-4 py-3 
                                   bg-[#198754] text-white rounded-xl font-semibold text-sm 
                                   hover:bg-[#156e43] transition-all duration-200"
                                >
                                    Get Started
                                    <ArrowRight size={16} />
                                </button>

                                <button
                                    onClick={handleRegisterRedirect}
                                    className="w-full px-4 py-3 border border-gray-300 rounded-xl 
                                   text-sm font-semibold hover:bg-gray-50 transition-all duration-200"
                                >
                                    Register
                                </button>
                            </>
                        )}

                        <button
                            onClick={handleLoginRedirect}
                            className="w-full flex justify-center items-center gap-2 px-4 py-3 
                           border border-gray-300 rounded-xl text-sm font-semibold 
                           hover:bg-gray-50 transition-all duration-200"
                        >
                            <LogIn size={16} />
                            {buttonLabel}
                        </button>
                    </div>
                )}
            </nav>

            {/* HERO */}
            <header className="max-w-7xl mx-auto px-6 pt-12 pb-20 grid lg:grid-cols-2 gap-12">
                <div>
                    <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-green-50 text-[#198754] text-xs font-bold mb-6">
                        <Star size={14} fill="currentColor" /> Used by 5,000+ Professionals
                    </div>

                    <h1 className="text-5xl lg:text-7xl font-black mb-6">
                        Landing your dream job starts{" "}
                        <span className="text-[#198754]">with a click.</span>
                    </h1>

                    <p className="text-slate-500 max-w-lg mb-10">
                        Choose from a wide selection of professionally designed CV templates built to perform with modern Applicant Tracking Systems (ATS), impress recruiters, and stand out in real-world hiring processes.
                        <br /><br />
                        Each template is carefully structured to highlight your skills, experience, and achievements in a clear and compelling
                    </p>

                    {/* <button
                        onClick={(handleGuestRedirect)}
                        className="flex items-center gap-3 px-8 py-4 bg-[#198754] text-white rounded-2xl font-black text-lg hover:bg-[#156e43]"
                    >
                        Get Started As Guest<ArrowRight />
                    </button> */}

                    {/* No Longer handling the LoginRedirect Here but handling the GuestRedirect; Will Change after finishing it */}
                    <div className="flex flex-col sm:flex-row gap-4 w-full">
                        <button
                            onClick={handleLoginRedirect}
                            className="flex items-center justify-center gap-2 w-full sm:w-auto px-6 py-3 sm:px-8 sm:py-4 
                   bg-[#198754] text-white rounded-2xl font-semibold text-base sm:text-lg 
                   hover:bg-[#156e43] transition-all duration-200 hover:scale-[1.02] active:scale-[0.98]"
                        >
                            Login <ArrowRight size={18} />
                        </button>

                        <button
                            onClick={handleGuestRedirect}
                            className="flex items-center justify-center gap-2 w-full sm:w-auto px-6 py-3 sm:px-8 sm:py-4 
                   bg-[#285E61] text-white rounded-2xl font-semibold text-base sm:text-lg 
                   hover:bg-[#234E52] transition-all duration-200 hover:scale-[1.02] active:scale-[0.98]"
                        >
                            <span className="truncate">Get Started as Guest</span>
                            <ArrowRight size={18} />
                        </button>
                    </div>

                    {/* <div className="flex">
                        <button
                            onClick={(handleLoginRedirect)}
                            className="flex items-center gap-3 px-8 py-4 bg-[#198754] text-white rounded-2xl font-black text-lg hover:bg-[#156e43]"
                        >
                            Login <ArrowRight />
                        </button>
                        <button
                            onClick={handleGuestRedirect}
                            className="flex items-center gap-3 px-8 py-4 bg-[#285E61] text-white rounded-2xl font-black text-lg hover:bg-[#234E52] ml-5"
                        >
                            Get Started As Guest <ArrowRight />
                        </button>
                    </div> */}
                </div>

                {/* TEMPLATE GRID */}
                <div className="grid grid-cols-2 gap-6">
                    {templates.slice(0, 4).map((t) => (
                        <div
                            key={t.id}
                            className="rounded-2xl overflow-hidden border shadow-lg aspect-[3/4]"
                        >
                            {t.preview}
                        </div>
                    ))}
                </div>
            </header>

            {/* TEMPLATE GALLERY */}
            <section className="bg-slate-50 py-24 px-6">
                <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-8">
                    {templates.map((t) => (
                        <div
                            key={t.id}
                            className="bg-white rounded-3xl border p-4 hover:shadow-xl transition"
                        >
                            <div className="aspect-[3/4] rounded-xl overflow-hidden mb-4 border">
                                {t.preview}
                            </div>
                            <h3 className="font-black text-lg">{t.name}</h3>
                        </div>
                    ))}
                </div>
            </section>

            {/* --- Final CTA --- */}
            <section className="px-6 mb-24">
                <div className="max-w-5xl mx-auto bg-slate-900 rounded-[3rem] p-12 md:p-20 text-center relative overflow-hidden">
                    <div className="absolute top-0 left-0 w-full h-full bg-[#198754] opacity-10 pointer-events-none" />
                    <h2 className="text-3xl md:text-5xl font-black text-white mb-8 relative z-10">
                        Ready to build your <br />future career?
                    </h2>
                    <span
                        disabled={true}
                        className="px-10 py-5 text-white rounded-2xl font-black text-xl hover:scale-105 transition-transform shadow-2xl relative z-10"
                    >
                        Login & Start Building Today!
                        {/* After fixing this, you also have to fix the login button at the top right corner. */}
                    </span>
                </div>
            </section>

            {/* --- Footer --- */}
            <footer className="py-12 border-t border-slate-100 text-center">
                <p className="text-slate-400 text-sm font-medium">© 2026 CV Gen. Powered by Signup.com.ng</p>
            </footer>
        </div>
    );
};



const SignupForm = ({ setAuth, navigate }) => {
    const [firstname, setfirstname] = useState('')
    const [lastname, setlastname] = useState('')
    const [email, setemail] = React.useState('');
    const [phone, setphone] = React.useState('');
    const [password, setPassword] = React.useState('');
    const [password_confirmation, setpassword_confirmation] = React.useState('');
    const [status, setStatus] = React.useState(null); // 'loading', 'error'

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('loading');

        try {
            const response = await fetch(`${AUTH_API_URL}/register`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ firstname, lastname, email, phone, password, password_confirmation }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Signup failed.');
            }

            // Assuming registration also returns a token and user details

            // const token = data.token;
            // const initialUserDetails = data.user;
            // saveAuthDetails(token, userDetails, setAuth);

            // Removing the lines above because we no longer automatically log the user in after signup. 
            // They must verify their email first and then log in.

            setStatus('success');
            navigate('request-email'); // Navigate to Another Page to request verification email

        } catch (error) {
            console.error('Signup Error:', error);
            setStatus('error');
        }
    };

    return (
        <form onSubmit={handleSubmit} className="p-6 sm:p-10 bg-white rounded-xl shadow-2xl max-w-sm mx-auto my-10 space-y-4">
            <h2 className="text-3xl font-extrabold text-gray-900 text-center mb-6">📝 Sign Up</h2>
            {status === 'error' && (
                <div className="p-3 text-sm text-red-800 rounded-lg bg-red-50">Signup failed. {status === 'loading' ? '' : 'User may already exist or there was a server error.'}</div>
            )}

            <input type="text" value={firstname} onChange={(e) => setfirstname(e.target.value)} placeholder="First Name" className={inputClasses} required />
            <input type="text" value={lastname} onChange={(e) => setlastname(e.target.value)} placeholder="Last Name" className={inputClasses} required />
            <input type="email" value={email} onChange={(e) => setemail(e.target.value)} placeholder="Email" className={inputClasses} required />
            <input type="number" value={phone} onChange={(e) => setphone(e.target.value)} placeholder="Phone Number" className={inputClasses} required />
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className={inputClasses} required />
            <input type="password" value={password_confirmation} onChange={(e) => setpassword_confirmation(e.target.value)} placeholder="Confirm Password" className={inputClasses} required />


            <button type="submit" disabled={status === 'loading'} className="w-full py-3 rounded-lg font-bold text-white bg-[#198754] hover:bg-[#156e43] transition duration-150 shadow-md">
                {status === 'loading' ? 'Signing up...' : 'Sign Up'}
            </button>
            <p className="text-center text-sm text-gray-600">
                Already have an account?{' '}
                <button type="button" onClick={() => navigate('login')} className="text-[#198754] hover:underline font-medium">Log In</button>
            </p>
        </form>
    );
};

// Assuming your API endpoint for sending the verification email is defined here
// const VERIFICATION_SEND_ENDPOINT = 'https://test.signup.com.ng/v1/api/auth/email/resend';
const VERIFICATION_SEND_ENDPOINT = 'https://cv.signup.com.ng/v1/api/auth/email/resend';

const EmailRequestForm = ({ navigate }) => {
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [statusMessage, setStatusMessage] = useState({ type: null, text: '' });

    const handleSendVerificationEmail = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setStatusMessage({ type: null, text: '' });

        try {
            const response = await fetch(VERIFICATION_SEND_ENDPOINT, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email }), // Send the entered email
            });

            const responseData = await response.json();

            if (!response.ok) {
                // Handle API errors (e.g., email not found, already verified, etc.)
                throw new Error(responseData.message || `HTTP Error: ${response.status}`);
            }

            // Success: Email sent successfully
            setStatusMessage({
                type: 'success',
                text: 'Verification email successfully sent! Please check your inbox.'
            });

            // After success, navigate to a confirmation page or prompt for login
            // For now, let's keep the user on the page and show success

        } catch (error) {
            console.error("Verification email request failed:", error);
            setStatusMessage({
                type: 'error',
                text: error.message || 'Failed to send verification email. Please try again.'
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="max-w-md mx-auto p-8 border rounded-xl shadow-lg bg-white">
            <h2 className="text-3xl font-bold mb-6 text-gray-900">Request Verification Email</h2>
            <p className="mb-6 text-gray-600">
                To complete your registration, please enter your email address to receive the verification link.
            </p>

            <form onSubmit={handleSendVerificationEmail}>
                <div className="mb-4">
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email Address</label>
                    <input
                        type="email"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[#198754] focus:border-[#198754]"
                        placeholder="your.email@example.com"
                        disabled={isLoading}
                    />
                </div>

                {statusMessage.text && (
                    <div className={`p-3 rounded-md mb-4 ${statusMessage.type === 'error' ? 'bg-red-100 text-red-800' : 'bg-green-100 text-green-800'}`}>
                        {statusMessage.text}
                    </div>
                )}

                <button
                    type="submit"
                    className={`w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white transition duration-200 ${isLoading ? 'bg-gray-400' : 'bg-[#198754] hover:bg-green-700'}`}
                    disabled={isLoading}
                >
                    {isLoading ? 'Sending...' : 'Send Verification Email'}
                </button>
            </form>

            <p className="mt-6 text-center text-sm">
                Already verified? <button onClick={() => navigate('login')} className="text-[#198754] hover:underline">Go to Sign In</button>
            </p>
        </div>
    );
};



// --- MAIN APP COMPONENT ---
const App = () => {
    const [templates, setTemplates] = useState([]);
    const [loadingTemplates, setLoadingTemplates] = useState(true);

    // const [isReferred, setIsReferred] = useState(null);

    const [isAuthenticating, setIsAuthenticating] = useState(false);

    // We use a custom string state for login/signup, and numbers for main app steps
    const [navigationState, setNavigationState] = useState({
        step: 'login', // Initial step is 'login' or 'signup'
        cvIdToEdit: null
    });

    const { auth, logout, setAuth } = useAuth(); // Get auth state and functions

    // const isReferred = auth?.is_referred;

    const isCallbackPage = window.location.href === "https://cv.signup.com.ng/auth/callback";
    const buttonLabel = isCallbackPage ? "Go To Dashboard" : "Login Now";

    async function getCVPrice(isReferred) {
        console.log("getCVPrice() CALLED with:", isReferred);

        try {
            const response = await fetch(`${CV_PURCHASE_BASE_URL}/price`);
            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || "Failed to fetch CV price");
            }

            const price = isReferred
                ? data?.referral_price
                : data?.price;

            console.log("FINAL PRICE:", price);

            return Number(price ?? 0);

        } catch (error) {
            console.error("Error fetching CV price:", error);
            return 0;
        }
    }

    // useEffect(() => {
    //     const fetchPrice = async () => {
    //         try {
    //             if (typeof isReferred !== 'boolean') return;

    //             console.log("Fetching price with isReferred:", isReferred);

    //             const price = await getCVPrice(isReferred);

    //             setPurchaseAmount(price);

    //         } catch (err) {
    //             console.error("Failed to fetch CV price:", err);
    //             setPurchaseAmount(0);
    //         }
    //     };

    //     fetchPrice();

    // }, [isReferred]);

    // useEffect(() => {
    //     const handleCallback = async () => {
    //         const params = new URLSearchParams(window.location.search);
    //         const ticket = params.get('ticket');

    //         if (!ticket) return;

    //         setIsAuthenticating(true);
    //         try {
    //             const response = await fetch('https://cv.signup.com.ng/v1/api/auth/login', {
    //                 method: 'POST',
    //                 headers: { 'Content-Type': 'application/json' },
    //                 body: JSON.stringify({ ticket })
    //             });

    //             console.log(response);

    //             if (!response.ok) throw new Error('Token exchange failed');

    //             const data = await response.json();
    //             if (!data.token) throw new Error('Token missing in response');
    //             console.log(data.user.referral_code);

    //             // Store token for subsequent API calls
    //             localStorage.setItem('auth_token', data.token);

    //             localStorage.setItem('referral_code', data.user.referral_code);

    //             console.log("FULL AUTH RESPONSE:", data);
    //             console.log("REFERRAL CODE:", data.user.referral_code);
    //             // const isUserReferred = data.user.is_referred;
    //             // console.log("Was User Referred?", data.user.is_referred);

    //             // if (isUserReferred) {
    //             //     setIsReferred(true);
    //             // }
    //             // else {
    //             //     setIsReferred(false);
    //             // }
    //             // Remove ticket from URL for security
    //             window.history.replaceState({}, document.title, window.location.pathname);

    //             // Optional: Fetch actual user data using the new token to populate the form
    //             // fetchUserData(data.token);

    //             console.log("Authentication successful, token stored.");
    //         } catch (error) {
    //             console.error('Login failed:', error);
    //         } finally {
    //             setIsAuthenticating(false);
    //         }
    //     };


    //     handleCallback();
    // }, []);

    // login callback

    useEffect(() => {
        const handleCallback = async () => {
            const params = new URLSearchParams(window.location.search);
            const ticket = params.get('ticket');

            if (!ticket) return;

            setIsAuthenticating(true);
            try {
                const response = await fetch(
                    'https://cv.signup.com.ng/v1/api/auth/login',
                    {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ ticket })
                    }
                );

                if (!response.ok) throw new Error('Token exchange failed');

                const data = await response.json();

                if (!data.token) throw new Error('Token missing in response');

                console.log("FULL AUTH RESPONSE:", data);

                // ✅ Use saveAuthDetails to update context AND localStorage
                saveAuthDetails(data.token, data.user, setAuth);

                // Remove ticket from URL for security
                window.history.replaceState({}, document.title, window.location.pathname);

                // Delaying Navigation for React to settle.
                // setTimeout(() => {
                //     navigate(4);
                // }, 0);

                console.log("Authentication successful, token stored.");
            } catch (error) {
                console.error('Login failed:', error);
            } finally {
                setIsAuthenticating(false);
            }
        };

        handleCallback();
    }, []);

    // Redirecting if user is authenticated
    useEffect(() => {
        if (auth?.isAuthenticated && auth?.user) {
            navigate(4);
        }
    }, [auth]);

    const handleLoginRedirect = () => {
        window.location.href = "https://signup.com.ng/sso/authorize?service=cv-app";
    };

    // Use a unified navigate function
    const navigate = (newStep, cvId = null) => {
        setNavigationState({ step: newStep, cvIdToEdit: cvId });
    };

    // Redirect to the dashboard if a token exists but the user is on login/signup page
    useEffect(() => {
        if (auth.isAuthenticated && (navigationState.step === 'login' || navigationState.step === 'signup')) {
            navigate(4); // Navigate to dashboard (Step 4) after successful login
        } else if (!auth.isAuthenticated && navigationState.step !== 'login' && navigationState.step !== 'signup') {
            navigate('login'); // Redirect to login if a token is lost or doesn't exist
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [auth.isAuthenticated]);

    //     console.log("Submitting with Token:", localStorage.getItem('auth_token'), payload);

    //     setTimeout(() => {
    //         setIsSaving(false);
    //         alert("CV Updated successfully!");
    //     }, 1500);
    // };

    if (isAuthenticating) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-slate-50">
                <div className="text-center">
                    <Loader2 className="w-12 h-12 animate-spin text-indigo-600 mx-auto mb-4" />
                    <h2 className="text-xl font-semibold text-slate-700">Verifying Ticket...</h2>
                    <p className="text-slate-500">Please wait while we log you in securely.</p>
                </div>
            </div>
        );
    }





    // const handleLoginRedirect = () => {
    //     window.location.href = "https://signup.com.ng/sso/authorize?service=cv-app";
    // };



    // Conditionally render based on authentication status and step
    const renderStep = () => {
        // If not authenticated, show login/signup forms only
        if (!auth.isAuthenticated) {
            if (navigationState.step === 'signup') {
                return <SignupForm setAuth={setAuth} navigate={navigate} />;
            }
            // 💡 Add the new step here:
            if (navigationState.step === 'request-email') {
                return <EmailRequestForm navigate={navigate} />;
            }

            if (navigationState.step === 'guest') {
                return <Guest navigate={navigate} />;
            }

            // Default to login
            return <LoginForm setAuth={setAuth} navigate={navigate} />;

        }

        // If authenticated, render application steps
        switch (navigationState.step) {
            case 1:
                return (
                    // CVFormPage must now use the token from the AuthContext internally
                    <CVFormPage
                        navigate={navigate}
                        cvIdToEdit={navigationState.cvIdToEdit}
                    />
                );
            case 2:
                return <CVTemplatesPage navigate={navigate} />;
            case 3:
                return <CVDownloadPage navigate={navigate} />;
            case 4:
                return <UserDashboardPage navigate={navigate} />;
            case 5:
                return <LoginForm navigate={navigate} />;
            case 6:
                // return <PurchasePage navigate={navigate} />;  -- I want to create this new component here but still do everything inside this App.js file
            default:
                return <CVFormPage navigate={navigate} cvIdToEdit={navigationState.cvIdToEdit} />;
        }
    }

    return (
        <>
            <div className="p-4 flex justify-end bg-gray-100">
                {auth.isAuthenticated && (
                    <button
                        onClick={logout}
                        className="text-sm font-semibold text-white bg-red-500 hover:bg-red-600 px-3 py-1 rounded-full shadow-md transition duration-150"
                    >
                        Logout
                    </button>
                )}

                {/* {!localStorage.getItem('auth_token') && (
                    <div className="bg-amber-50 border-b border-amber-100 p-4 flex items-center justify-between">
                        <p className="text-amber-700 text-sm font-medium">You are not logged in. Your progress may not be saved.</p>
                        <button
                            onClick={handleLoginRedirect}
                            className="flex items-center text-xs bg-amber-600 text-white px-3 py-1.5 rounded-lg hover:bg-amber-700 font-bold"
                        >
                            <LogIn className="w-3 h-3 mr-1" />
                            {buttonLabel}
                        </button>


                    </div>
                )} */}
            </div>
            {renderStep()}
        </>
    );
}

// --- FINAL WRAPPER ---
// The AuthProvider wraps the main application to make the auth state available
const RootApp = () => (
    <AuthProvider>
        <CVProvider>
            <App />
        </CVProvider>
    </AuthProvider>
);

export default RootApp;

// Add the LoginForm and SignupForm components from Section 1 here, and your CVFormPage etc.
// NOTE: For a single file, you'd put all the JSX components (CVFormPage, CVTemplatesPage, etc.)
// right into this file as well.